
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kTkGJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<8efba80de4dcbadbb0d8fe2756aad825>>
 * @relayHash 1dfb5d1a396763fa09c23a7d3dd9b907
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dcac1065021e8eed6836f544598af5dbb8eff0ad06733c29f24311510938c533
const $a98d354945884061$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsContentStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsContentStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1dfb5d1a396763fa09c23a7d3dd9b907",
            "id": "dcac1065021e8eed6836f544598af5dbb8eff0ad06733c29f24311510938c533",
            "metadata": {},
            "name": "ReactionsContentStatusQuery",
            "operationKind": "query",
            "text": "query ReactionsContentStatusQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,status}}}"
        }
    };
}();
$a98d354945884061$var$node.hash = "9f959366bff39d8d4cb18c6f15da5424";
var $a98d354945884061$export$2e2bcd8739ae039 = $a98d354945884061$var$node;


/**
 * @generated SignedSource<<7c82f2cd1c5911d892baefa06b158047>>
 * @relayHash 5cdc9e619e9ffae1c2458a65cae82b9e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3b89f2b87ad307d276c00cab8c433a41fbeeaac1a710af6df64ee8225fcddef3
const $52ac30efaee3411d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerType"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "emojiId"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "containerId",
                    "variableName": "containerId"
                },
                {
                    "kind": "Variable",
                    "name": "containerType",
                    "variableName": "containerType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                },
                {
                    "kind": "Variable",
                    "name": "emojiId",
                    "variableName": "emojiId"
                }
            ],
            "concreteType": "SaveReactionResponse",
            "kind": "LinkedField",
            "name": "deleteReaction",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "ari"
                },
                {
                    "kind": "ScalarField",
                    "name": "containerAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactionsDeleteReactionMutation",
            "selections": v5 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactionsDeleteReactionMutation",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "5cdc9e619e9ffae1c2458a65cae82b9e",
            "id": "3b89f2b87ad307d276c00cab8c433a41fbeeaac1a710af6df64ee8225fcddef3",
            "metadata": {},
            "name": "ReactionsDeleteReactionMutation",
            "operationKind": "mutation",
            "text": "mutation ReactionsDeleteReactionMutation($contentId:String!,$containerId:String!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){deleteReaction(contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId){ari,containerAri,emojiId}}"
        }
    };
}();
$52ac30efaee3411d$var$node.hash = "9036981d01949a3e096cd7af290a477d";
var $52ac30efaee3411d$export$2e2bcd8739ae039 = $52ac30efaee3411d$var$node;


/**
 * @generated SignedSource<<8da2aab319b042da2fc53c615aea70c2>>
 * @relayHash 585935353be655fa901655a87abfee97
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b346b69a2ac553d8cbea80e17f800abbf81b473a35dd03bb3e2add77fbb033b2
const $0339cd518b8339bc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "emojiId"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "containerId",
                            "variableName": "containerId"
                        },
                        {
                            "kind": "Variable",
                            "name": "containerType",
                            "variableName": "containerType"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentType",
                            "variableName": "contentType"
                        },
                        {
                            "kind": "Variable",
                            "name": "emojiId",
                            "variableName": "emojiId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConfluenceReactionPayload",
            "kind": "LinkedField",
            "name": "confluence_addReaction",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "ari"
                },
                {
                    "kind": "ScalarField",
                    "name": "containerAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactionsConfluenceSaveReactionMutation",
            "selections": v6 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactionsConfluenceSaveReactionMutation",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "585935353be655fa901655a87abfee97",
            "id": "b346b69a2ac553d8cbea80e17f800abbf81b473a35dd03bb3e2add77fbb033b2",
            "metadata": {},
            "name": "ReactionsConfluenceSaveReactionMutation",
            "operationKind": "mutation",
            "text": "mutation ReactionsConfluenceSaveReactionMutation($cloudId:ID!,$contentId:Long!,$containerId:Long!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){confluence_addReaction(cloudId:$cloudId,input:{contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId}){ari,containerAri,emojiId}}"
        }
    };
}();
$0339cd518b8339bc$var$node.hash = "8801ac011dd1c9144f2e5afc0393b4f7";
var $0339cd518b8339bc$export$2e2bcd8739ae039 = $0339cd518b8339bc$var$node;



var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");

var $inPa6 = parcelRequire("inPa6");


var $ibzAc = parcelRequire("ibzAc");


var $7G5ZJ = parcelRequire("7G5ZJ");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $isEtk = parcelRequire("isEtk");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $32x2E = parcelRequire("32x2E");


var $hl1Kw = parcelRequire("hl1Kw");


var $7W8i8 = parcelRequire("7W8i8");


var $aqvyf = parcelRequire("aqvyf");


var $2VQ4B = parcelRequire("2VQ4B");


var $bQm3c = parcelRequire("bQm3c");


var $a6t12 = parcelRequire("a6t12");


var $yuV6Z = parcelRequire("yuV6Z");


var $8SCD6 = parcelRequire("8SCD6");

/**
 * @generated SignedSource<<1e2a404018a855dd6db8864b2af5e5fa>>
 * @relayHash 222c6cbd9725abb2c8498135788f422a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 21e52966fb7b1fdd9c3afd1de64070e1b83d5c73c8fb31fa62c895a6ca04053f
const $372e27c1a81438b1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isCurrentUserContributor"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsEligibleForContextualCollabOnboardingContentContributorsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsEligibleForContextualCollabOnboardingContentContributorsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "222c6cbd9725abb2c8498135788f422a",
            "id": "21e52966fb7b1fdd9c3afd1de64070e1b83d5c73c8fb31fa62c895a6ca04053f",
            "metadata": {},
            "name": "useIsEligibleForContextualCollabOnboardingContentContributorsQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForContextualCollabOnboardingContentContributorsQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}"
        }
    };
}();
$372e27c1a81438b1$var$node.hash = "ffb84dbb2774981b29c29e7117a0cf7c";
var $372e27c1a81438b1$export$2e2bcd8739ae039 = $372e27c1a81438b1$var$node;


/**
 * @generated SignedSource<<394265a4b78b5fa136c42c3d5d516c81>>
 * @relayHash b0304b30a3bb95bf6c9c33a987bf6502
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 230bff51677d6e64e9e9997b08ce4053a4ce484bcf1c809f98c7a33164d8942b
const $87e18238c7709b4a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        },
        {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "limit",
            "value": 1
        }
    ], v3 = {
        "concreteType": "ContentAnalyticsPageViewInfo",
        "kind": "LinkedField",
        "name": "pageViews",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastViewedAt"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ContentAnalyticsViewsByUser",
                    "kind": "LinkedField",
                    "name": "contentAnalyticsViewsByUser",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ContentAnalyticsViewsByUser",
                    "kind": "LinkedField",
                    "name": "contentAnalyticsViewsByUser",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b0304b30a3bb95bf6c9c33a987bf6502",
            "id": "230bff51677d6e64e9e9997b08ce4053a4ce484bcf1c809f98c7a33164d8942b",
            "metadata": {},
            "name": "useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForContextualCollabOnboardingContentAnalyticsViewsByUserQuery($contentId:ID!,$accountIds:[String]){contentAnalyticsViewsByUser(contentId:$contentId,limit:1,accountIds:$accountIds){pageViews{lastViewedAt},id}}"
        }
    };
}();
$87e18238c7709b4a$var$node.hash = "b6371dfe1f821106109b0727fa093847";
var $87e18238c7709b4a$export$2e2bcd8739ae039 = $87e18238c7709b4a$var$node;


/**
 * @generated SignedSource<<65fe882ad6e74fceb7b4180929e49f1c>>
 * @relayHash dc69747871f66e54a667ab760cd83b71
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a00c866014cd4bfbd001c3ae9b402e6a8875822a433b175c96777343c35d74a
const $8085d05d0fcc0c92$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "status.0",
                    "variableName": "status"
                }
            ],
            "kind": "ListValue",
            "name": "status"
        }
    ], v2 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsEligibleForContextualCollabOnboardingGeneratedByQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsEligibleForContextualCollabOnboardingGeneratedByQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "dc69747871f66e54a667ab760cd83b71",
            "id": "5a00c866014cd4bfbd001c3ae9b402e6a8875822a433b175c96777343c35d74a",
            "metadata": {},
            "name": "useIsEligibleForContextualCollabOnboardingGeneratedByQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForContextualCollabOnboardingGeneratedByQuery($contentId:ID!,$status:String!){content(id:$contentId,status:[$status]){nodes{contentProperties{latest{generatedBy}},id}}}"
        }
    };
}();
$8085d05d0fcc0c92$var$node.hash = "7517f0ea4189fbac1a827ee6d3652a0d";
var $8085d05d0fcc0c92$export$2e2bcd8739ae039 = $8085d05d0fcc0c92$var$node;



var $8dwdz = parcelRequire("8dwdz");


var $ivb8S = parcelRequire("ivb8S");





var $dBcar = parcelRequire("dBcar");


var $jMyy4 = parcelRequire("jMyy4");





var $dPJCf = parcelRequire("dPJCf");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $2c10e620583c8537$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $2c10e620583c8537$var$useReplyToCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $2c10e620583c8537$export$38e307e1a9b9b740 = (0, $8085d05d0fcc0c92$export$2e2bcd8739ae039);
const $2c10e620583c8537$export$a99ff30d068552ef = (0, $87e18238c7709b4a$export$2e2bcd8739ae039);
const $2c10e620583c8537$export$ba27c58f460f6113 = (0, $372e27c1a81438b1$export$2e2bcd8739ae039);
const $2c10e620583c8537$export$f37a6378fd099d73 = ({ contentId: contentId, contentType: contentType, contentStatus: contentStatus, isLivePage: isLivePage, skip: skip })=>{
    const isEditMode = (0, $de2j9.useIsEditorPage)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isDesktopUser = !((0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)());
    const focusedCommentIdFromCommentLink = $2c10e620583c8537$var$useFocusedCommentIdQueryParam();
    const replyToCommentId = $2c10e620583c8537$var$useReplyToCommentIdQueryParam();
    const isCommentLinkNavigation = Boolean(focusedCommentIdFromCommentLink || replyToCommentId);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN
    ], skip || !(0, $9wGTI.fg)('cc_engagement_contextual_collab_onboarding_for_neu') && !(0, $9wGTI.fg)('cc_engagement_contextual_collab_neu_aa_gate'));
    const { isFoundingAdmin: isFoundingAdmin } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const isNthUser = !isFoundingAdmin && !onboardingStateLoading && !onboardingStateError;
    const isValidContent = contentType === 'page' && !isEditMode || isLivePage;
    const generatedByQuery = (0, $jMyy4.useQueryInterop)($2c10e620583c8537$export$38e307e1a9b9b740, {
        variables: {
            contentId: contentId,
            status: contentStatus ?? ''
        },
        skip: skip || !isNthUser || !contentId || !isValidContent || contentStatus === (0, $cD1qu.ContentStatus).DRAFT || !(0, $9wGTI.fg)('cc_engagement_contextual_collab_onboarding_for_neu') && !(0, $9wGTI.fg)('cc_engagement_contextual_collab_neu_aa_gate')
    });
    const generatedBy = generatedByQuery.data?.content?.nodes?.[0]?.contentProperties?.latest?.generatedBy;
    // Copied from GeneratedBy.java Monolith file
    const isAutoGenerated = !generatedByQuery.error && !generatedByQuery.loading && (generatedBy === 'ONBOARDING' || generatedBy === 'ROVO_SMART_CREATION');
    const contentAnalyticsViewsByUserQuery = (0, $jMyy4.useQueryInterop)($2c10e620583c8537$export$a99ff30d068552ef, {
        variables: {
            contentId: contentId,
            accountIds: [
                userId
            ]
        },
        fetchPolicy: 'network-only',
        skip: skip || userId === null || !isNthUser || !isValidContent || isAutoGenerated || !(0, $9wGTI.fg)('cc_engagement_contextual_collab_onboarding_for_neu') && !(0, $9wGTI.fg)('cc_engagement_contextual_collab_neu_aa_gate')
    });
    const pageViews = contentAnalyticsViewsByUserQuery.data?.contentAnalyticsViewsByUser?.pageViews ?? [];
    const hasConfirmedPriorVisit = !contentAnalyticsViewsByUserQuery.error && !contentAnalyticsViewsByUserQuery.loading && pageViews.length > 0;
    const contributorQuery = (0, $jMyy4.useQueryInterop)($2c10e620583c8537$export$ba27c58f460f6113, {
        variables: {
            contentId: contentId
        },
        skip: skip || !isNthUser || !isValidContent || !hasConfirmedPriorVisit || isAutoGenerated || !(0, $9wGTI.fg)('cc_engagement_contextual_collab_onboarding_for_neu') && !(0, $9wGTI.fg)('cc_engagement_contextual_collab_neu_aa_gate')
    });
    const isCurrentUserContributor = !contributorQuery.error && !contributorQuery.loading && Boolean(contributorQuery.data?.contentContributors?.isCurrentUserContributor);
    return {
        isEligibleForSpotlight: isDesktopUser && isNthUser && isValidContent && !isAutoGenerated && hasConfirmedPriorVisit && !isCurrentUserContributor && !isCommentLinkNavigation
    };
};


/* EmojiPopoverSpotlightWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1cfRh = parcelRequire("1cfRh");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");


var $fT2ta = parcelRequire("fT2ta");


var $h82at = parcelRequire("h82at");

const $e0c08f246e3009d7$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    spotlightHeadline: {
        id: "experiment-contextual-collab-onboarding-for-new-end-users.emoji-popover-spotlight.headline",
        defaultMessage: "Share your reaction"
    },
    spotlightBody: {
        id: "experiment-contextual-collab-onboarding-for-new-end-users.emoji-popover-spotlight.body",
        defaultMessage: "Leave a quick reaction to let your teammates know what you think!"
    },
    spotlightDone: {
        id: "experiment-contextual-collab-onboarding-for-new-end-users.emoji-popover-spotlight.done",
        defaultMessage: "OK"
    }
});


const $40cb788b40fb0a3a$var$spotlightBodyStyles = null;
const $40cb788b40fb0a3a$var$noop = ()=>{};
const $40cb788b40fb0a3a$export$48224dc58d5614a5 = ({ children: children, showSpotlight: showSpotlight })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    if (!showSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        dismiss: $40cb788b40fb0a3a$var$noop,
        done: $40cb788b40fb0a3a$var$noop,
        placement: "left-end",
        isVisible: true,
        offset: [
            40,
            10
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "left"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: "emoji-popover-spotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage((0, $e0c08f246e3009d7$export$a7357cdd1f0b0168).spotlightHeadline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _1bsb1osq _p12f1osq _slp31hna _1i4q1hna _o5724jg8"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $e0c08f246e3009d7$export$a7357cdd1f0b0168).spotlightBody)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage((0, $e0c08f246e3009d7$export$a7357cdd1f0b0168).spotlightDone))))))))));
};



var $6mKj3 = parcelRequire("6mKj3");

const $ea7c14fef1b23d1f$var$THUMBS_UP = '1f44d';
const $ea7c14fef1b23d1f$var$CLAP = '1f44f';
const $ea7c14fef1b23d1f$var$TADA = '1f389';
const $ea7c14fef1b23d1f$export$68fb1297e1fdf33e = [
    $ea7c14fef1b23d1f$var$THUMBS_UP,
    $ea7c14fef1b23d1f$var$CLAP,
    $ea7c14fef1b23d1f$var$TADA
];



var $bFPHx = parcelRequire("bFPHx");


var $5Kc7f = parcelRequire("5Kc7f");











var $hiS1z = parcelRequire("hiS1z");


var $a3fRD = parcelRequire("a3fRD");


var $3gadb = parcelRequire("3gadb");





var $1uFM6 = parcelRequire("1uFM6");





var $hjygH = parcelRequire("hjygH");


var $7Sm4c = parcelRequire("7Sm4c");




const $055b8cdcd211a3e7$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    errorTitle: {
        id: "reactions.error.title.generic",
        defaultMessage: "We couldn\u2019t update the reaction"
    },
    errorMessage: {
        id: "reactions.error.message.generic",
        defaultMessage: "If the problem persists, contact {atlassianSupportLink} or your space admin so they can troubleshoot the issue."
    },
    noReactions: {
        id: "reactions.no.page.reactions",
        defaultMessage: "Be the first to add a reaction"
    },
    viewError: {
        id: "reactions.view.error",
        defaultMessage: "Reactions failed to load"
    },
    viewErrorTooltip: {
        id: "reactions.view.error.tooltip",
        defaultMessage: "Refresh to try again"
    },
    addMutationError: {
        id: "reactions.mutation.add.error",
        defaultMessage: "Couldn\u2019t add reaction"
    },
    deleteMutationError: {
        id: "reactions.mutation.delete.error",
        defaultMessage: "Couldn\u2019t delete reaction"
    },
    mutationErrorAction: {
        id: "reactions.mutation.error.action",
        defaultMessage: "Try again"
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e5f8cfebc971936$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { location: location, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm _80om13gf",
            __cmplp.location === "page-comment" || __cmplp.location === "inline-comment" || __cmplp.location === "editor-inline-comment" ? "_19bv1y44" : "_19bvidpf",
            __cmplp.location === "inline-comment" || __cmplp.location === "editor-inline-comment" || __cmplp.location === "page-comment" ? "_154i1y44" : "_154iidpf",
            __cmplp.location === "inline-comment" || __cmplp.location === "editor-inline-comment" ? "_syaz1rpy" : "_syazazsu",
            __cmplp.location === "inline-comment" || __cmplp.location === "editor-inline-comment" ? "_1wyb1crf" : "_1wyb1kw7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $9e5f8cfebc971936$var$TextContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        const { location: location, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.location === "page" ? "_154i1lpd" : "_154iyjp0",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $9e5f8cfebc971936$export$1cbf5121ff654d85 = (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { error: error, location: location } = t0;
    const isComment = location === "page-comment" || location === "inline-comment" || location === "editor-inline-comment";
    if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    let t1;
    if ($[0] !== error) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
            name: (0, $irVI7.VIEW_REACTIONS_EXPERIENCE),
            error: error
        });
        $[0] = error;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = isComment ? (0, $055b8cdcd211a3e7$export$a7357cdd1f0b0168).viewError : (0, $055b8cdcd211a3e7$export$a7357cdd1f0b0168).viewErrorTooltip;
    let t3;
    if ($[2] !== isComment || $[3] !== location) {
        t3 = (tooltipText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: tooltipText,
                position: "top-start"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                color: location === "inline-comment" || location === "editor-inline-comment" ? "var(--ds-icon-accent-gray, #7D818A)" : "var(--ds-icon-subtle, #505258)",
                label: "Icon showing an error with rendering reactions",
                spacing: "spacious"
            }), !isComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e5f8cfebc971936$var$TextContainer, {
                location: location
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $055b8cdcd211a3e7$export$a7357cdd1f0b0168).viewError)));
        $[2] = isComment;
        $[3] = location;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), t2, t3);
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== location || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e5f8cfebc971936$var$Container, {
            location: location
        }, t4);
        $[8] = location;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== error || $[12] !== t1 || $[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }, t1, t5);
        $[11] = error;
        $[12] = t1;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
};



var $2OQgp = parcelRequire("2OQgp");











var $aoVih = parcelRequire("aoVih");

var $iHPbg = parcelRequire("iHPbg");


var $ewCYL = parcelRequire("ewCYL");


const $ab5f533f273a9a39$export$8dff3eb53fad3d32 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { isPage: isPage, resetErrorStates: resetErrorStates, addMutationError: addMutationError, deleteMutationError: deleteMutationError } = t0;
    let t1;
    if ($[0] !== addMutationError || $[1] !== deleteMutationError || $[2] !== isPage || $[3] !== resetErrorStates) {
        t1 = isPage && (addMutationError || deleteMutationError) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ewCYL.MutationErrorContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            appearance: "error",
            actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iHPbg.default), {
                onClick: resetErrorStates
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $055b8cdcd211a3e7$export$a7357cdd1f0b0168).mutationErrorAction))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), addMutationError ? (0, $055b8cdcd211a3e7$export$a7357cdd1f0b0168).addMutationError : (0, $055b8cdcd211a3e7$export$a7357cdd1f0b0168).deleteMutationError))) : null;
        $[0] = addMutationError;
        $[1] = deleteMutationError;
        $[2] = isPage;
        $[3] = resetErrorStates;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};












var $3jwuS = parcelRequire("3jwuS");





var $8wyJO = parcelRequire("8wyJO");


var $5qhgL = parcelRequire("5qhgL");




const $67ab6f98e2c53f50$export$66ed1c8ad044cd30 = (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { location: location, contentId: contentId, containerId: containerId, reactedUsersMap: reactedUsersMap, useNetworkOnly: useNetworkOnly, inheritedReactionsData: inheritedReactionsData, limit: limit, sort: sort } = t0;
    const { isComment: isComment } = (0, $5qhgL.getBooleanLocationTypes)(location);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isClassicEditPage = (0, $de2j9.useIsEditorPage)();
    const isLivePageSSRMode = isLivePage && Boolean(window.__SSR_RENDERED__);
    const { query: query, queryVariables: queryVariables } = (0, $8wyJO.getReactionsQueryInfo)(isComment, contentId, containerId);
    const defaultFetchPolicy = (0, $6mKj3.expVal)("confluence_fe_use_reactions_data_cache_first", "isEnabled", false) ? "cache-first" : "cache-and-network";
    const t1 = isComment && useNetworkOnly ? "network-only" : defaultFetchPolicy;
    const t2 = inheritedReactionsData !== undefined;
    let t3;
    if ($[0] !== queryVariables || $[1] !== t1 || $[2] !== t2) {
        t3 = {
            variables: queryVariables,
            fetchPolicy: t1,
            skip: t2
        };
        $[0] = queryVariables;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)(query, t3);
    let t4;
    bb0: {
        const showPreloadedDataDuringLoading = isLivePageSSRMode || (isLivePage || isClassicEditPage) && (0, $9wGTI.fg)("confluence_perf_reactions_load_livepage") || window.__SSR_REACT_STREAMING__;
        const shouldShowEmptyState = loading && !showPreloadedDataDuringLoading || error || !data && !inheritedReactionsData;
        if (shouldShowEmptyState) {
            let t5;
            if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
                t5 = {
                    reactions: [],
                    totalCount: 0,
                    ari: "",
                    containerAri: ""
                };
                $[4] = t5;
            } else t5 = $[4];
            let t6;
            if ($[5] !== error || $[6] !== loading) {
                t6 = {
                    data: t5,
                    loading: loading,
                    error: error
                };
                $[5] = error;
                $[6] = loading;
                $[7] = t6;
            } else t6 = $[7];
            t4 = t6;
            break bb0;
        }
        let ari;
        let containerAri;
        let shapedReactions;
        let totalCount;
        if ($[8] !== data || $[9] !== inheritedReactionsData || $[10] !== limit || $[11] !== reactedUsersMap || $[12] !== sort) {
            const reactionsSummary = inheritedReactionsData || (0, $8wyJO.getReactionsSummary)(data);
            totalCount = reactionsSummary?.reactionsCount || 0;
            containerAri = reactionsSummary?.containerAri || "";
            ari = reactionsSummary?.ari || "";
            const reactionNodes = reactionsSummary?.reactionsSummaryForEmoji || [];
            const filteredNodes = reactionNodes?.filter($67ab6f98e2c53f50$var$_temp);
            shapedReactions = filteredNodes.map((t5)=>{
                const { emojiId: emojiId, count: count, reacted: reacted } = t5;
                const users = reactedUsersMap[emojiId] || [];
                return {
                    ari: ari,
                    containerAri: containerAri,
                    emojiId: emojiId,
                    count: count,
                    reacted: reacted,
                    users: users
                };
            });
            if (sort) {
                let t6;
                if ($[17] !== sort) {
                    t6 = (a, b)=>sort === "asc" ? a.count - b.count : b.count - a.count;
                    $[17] = sort;
                    $[18] = t6;
                } else t6 = $[18];
                shapedReactions = shapedReactions.sort(t6);
            }
            if (limit) shapedReactions = shapedReactions.slice(0, limit);
            $[8] = data;
            $[9] = inheritedReactionsData;
            $[10] = limit;
            $[11] = reactedUsersMap;
            $[12] = sort;
            $[13] = ari;
            $[14] = containerAri;
            $[15] = shapedReactions;
            $[16] = totalCount;
        } else {
            ari = $[13];
            containerAri = $[14];
            shapedReactions = $[15];
            totalCount = $[16];
        }
        let t5;
        if ($[19] !== ari || $[20] !== containerAri || $[21] !== shapedReactions || $[22] !== totalCount) {
            t5 = {
                data: {
                    totalCount: totalCount,
                    reactions: shapedReactions,
                    ari: ari,
                    containerAri: containerAri
                }
            };
            $[19] = ari;
            $[20] = containerAri;
            $[21] = shapedReactions;
            $[22] = totalCount;
            $[23] = t5;
        } else t5 = $[23];
        t4 = t5;
    }
    return t4;
};
function $67ab6f98e2c53f50$var$_temp(reaction) {
    return reaction !== null;
}



var $ke5Nx = parcelRequire("ke5Nx");








var $3FlVr = parcelRequire("3FlVr");


var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $550b25d93e8d59fc$export$248a931886e2c02d = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_REACTIONS_SEGMENT_KEY)
});
const $550b25d93e8d59fc$export$7d316e4a12cc793d = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FEED_REACTIONS_SEGMENT_KEY)
});


/* ReactionsPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 












'use no memo';
const $55d0a25426713acb$var$DefaultPromptStyles = null;
const $55d0a25426713acb$var$AnimatedPromptStyles = null;
const $55d0a25426713acb$export$a1009b06367a4913 = ({ isPage: isPage, isDisabled: isDisabled, readOnly: readOnly, isHidden: isHidden, hasAnimation: hasAnimation })=>{
    if (!isPage || isHidden || isDisabled || readOnly || (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": hasAnimation ? 'no-reactions-animated-text-prompt' : 'no-reactions-plain-text-prompt',
        className: (0, $gMc0m.default)([
            "_18u01b66",
            hasAnimation && "_pjrq1kdv _1y1m1kdv _syaz1j28 _1lrw6srv _1itkuo0v _7hjf6euv _j7hq5qox _5sagi11n _tip8cs5v _1pgl1ytf _ju25ymdr"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $055b8cdcd211a3e7$export$a7357cdd1f0b0168).noReactions));
};



var $etuMO = parcelRequire("etuMO");





var $308Wd = parcelRequire("308Wd");


var $c0rhi = parcelRequire("c0rhi");


var $86okN = parcelRequire("86okN");

const $f5eec8619482ab22$var$ReactionsConfluenceSaveReactionMutation = (0, $0339cd518b8339bc$export$2e2bcd8739ae039);
const $f5eec8619482ab22$var$ReactionsDeleteReactionMutation = (0, $52ac30efaee3411d$export$2e2bcd8739ae039);
const $f5eec8619482ab22$var$ReactionsContentStatusQuery = (0, $a98d354945884061$export$2e2bcd8739ae039);
const $f5eec8619482ab22$var$getDefaultOptimisticResponse = (emojiId)=>({
        __typename: 'Mutation',
        confluence_addReaction: {
            // @ts-expect-error - __typename does not exist in the generated artifacts data type but needed here.
            __typename: 'ConfluenceReactionPayload',
            ari: null,
            containerAri: null,
            emojiId: emojiId
        }
    });
const $f5eec8619482ab22$var$logger = (0, $7W8i8.getLogger)('reactions');
const $f5eec8619482ab22$var$noop = ()=>{};
const $f5eec8619482ab22$var$reactionsContainerStyles = (0, $ecnYn.xcss)({
    font: 'font.body.small',
    color: 'color.text.subtle'
});
const $f5eec8619482ab22$var$particleFadeAnimation = null;
const $f5eec8619482ab22$var$particleFloatAnimation = null;
const $f5eec8619482ab22$var$customParticleStyle = null;
const $f5eec8619482ab22$var$particleContainerStyle = null;
const $f5eec8619482ab22$var$RandomParticleEffect = (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { emojis: emojis, location: location, contentId: contentId, emojiProvider: emojiProvider, bylineContainerRef: bylineContainerRef } = t0;
    const [containerWidth, setContainerWidth] = (0, $42omo.useState)(100);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            left: 0,
            top: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const [reactionsPosition, setReactionsPosition] = (0, $42omo.useState)(t1);
    let t2;
    if ($[1] !== bylineContainerRef || $[2] !== contentId || $[3] !== emojis.length || $[4] !== location) {
        t2 = ()=>{
            const reactionContainerRef = document.querySelector(`#reactions-container-${location}-${contentId}`);
            if (emojis.length > 0 && bylineContainerRef?.current && reactionContainerRef) {
                const bylineRect = bylineContainerRef.current.getBoundingClientRect();
                const reactionContainerRect = reactionContainerRef.getBoundingClientRect();
                setContainerWidth(reactionContainerRect.width);
                setReactionsPosition({
                    left: reactionContainerRect.left - bylineRect.left,
                    top: reactionContainerRect.top - bylineRect.top
                });
            }
        };
        $[1] = bylineContainerRef;
        $[2] = contentId;
        $[3] = emojis.length;
        $[4] = location;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== bylineContainerRef || $[7] !== contentId || $[8] !== emojis || $[9] !== location) {
        t3 = [
            emojis,
            location,
            contentId,
            bylineContainerRef
        ];
        $[6] = bylineContainerRef;
        $[7] = contentId;
        $[8] = emojis;
        $[9] = location;
        $[10] = t3;
    } else t3 = $[10];
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[11] !== containerWidth || $[12] !== emojiProvider || $[13] !== emojis || $[14] !== reactionsPosition.left || $[15] !== reactionsPosition.top) {
        const generateRandomPosition = (particleIndex)=>{
            const offset = getParticleOffset(particleIndex);
            return {
                left: Math.random() * (containerWidth - 30) + offset,
                animationDelay: `${Math.random() * 600 + particleIndex * 150}ms`
            };
        };
        const getParticleOffset = $f5eec8619482ab22$var$_temp;
        let t5;
        if ($[17] !== containerWidth || $[18] !== reactionsPosition.left || $[19] !== reactionsPosition.top) {
            t5 = {
                top: reactionsPosition.top,
                left: reactionsPosition.left,
                width: containerWidth
            };
            $[17] = containerWidth;
            $[18] = reactionsPosition.left;
            $[19] = reactionsPosition.top;
            $[20] = t5;
        } else t5 = $[20];
        let t6;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = (0, $gMc0m.default)([
                "_kqswstnw _4t3i68cl _lcxvglyw _1pby15gg"
            ]);
            $[21] = t6;
        } else t6 = $[21];
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "random-particle-effect-container",
            style: t5,
            className: t6
        }, emojis.map((emojiId)=>Array.from({
                length: 3
            }, (_, particleIndex_0)=>{
                const randomPos = generateRandomPosition(particleIndex_0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    key: `${emojiId}-${particleIndex_0}`,
                    style: {
                        left: randomPos.left,
                        animationDelay: randomPos.animationDelay
                    },
                    className: (0, $gMc0m.default)([
                        "_y44vik89 _kqswstnw _154iidpf _1ltvidpf _lcxvglyw _tzy4idpf _5sagpwmj"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $etuMO.default), {
                    emojiProvider: emojiProvider,
                    emojiId: {
                        id: emojiId
                    },
                    fitToHeight: 24
                }));
            })));
        $[11] = containerWidth;
        $[12] = emojiProvider;
        $[13] = emojis;
        $[14] = reactionsPosition.left;
        $[15] = reactionsPosition.top;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
};
const $f5eec8619482ab22$export$44cd1c46d5ca2376 = ({ contentId: contentId, containerId: containerId, containerType: containerType, location: location, readOnly: readOnly, hidePlaceholder: hidePlaceholder, reactionsData: reactionsData, updateCache: updateCache, contentSubType: contentSubType, summaryViewEnabled: summaryViewEnabled = false, hideNoReactionsText: hideNoReactionsText = false, animateNoReactionsText: animateNoReactionsText = false, customAnalyticsAttributes: customAnalyticsAttributes = {}, summaryViewPlacement: summaryViewPlacement = 'top-end', popularFeedTimeGranularity: popularFeedTimeGranularity, isSubtle: isSubtle = false, limit: limit, sort: sort, onlyRenderPicker: onlyRenderPicker = false, showAddReactionText: showAddReactionText = true, isViewOnly: isViewOnly = false, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, showSubtleDefaultReactions: showSubtleDefaultReactions, allowUserDialog: allowUserDialog = true, noFlexWrap: noFlexWrap = false, noRelativeContainer: noRelativeContainer = false, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerTooltipContent: reactionPickerTriggerTooltipContent, reactionPickerTriggerText: reactionPickerTriggerText, allowSelectFromSummaryView: allowSelectFromSummaryView, summaryViewThreshold: summaryViewThreshold, useDefaultStyledContainer: useDefaultStyledContainer, useButtonAlignmentStyling: useButtonAlignmentStyling, reactionPickerPlacement: reactionPickerPlacement, hoverableSummaryView: hoverableSummaryView = false, isListItem: isListItem = false, summaryButtonIconAfter: summaryButtonIconAfter, optimisticallyLoadSummaryEmojis: optimisticallyLoadSummaryEmojis = false, getOptimisticResponse: getOptimisticResponse, particleEffectByEmoji: externalParticleEffectByEmoji, onParticleEffectChange: onParticleEffectChange, renderParticleEffectOnSummaryView: renderParticleEffectOnSummaryView = false, renderParticleEffectOnLoad: renderParticleEffectOnLoad = false, bylineContainerRef: bylineContainerRef })=>{
    const scrollFunctionRef = (0, $42omo.useRef)(()=>void 0);
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const firstRenderRef = (0, $42omo.useRef)(false);
    const activeReactionsRef = (0, $42omo.useRef)([]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: userId, cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Only add experiment attributes for comment-related reaction locations
    const isCommentReaction = location === (0, $3FlVr.ReactionLocation).PAGE_COMMENT || location === (0, $3FlVr.ReactionLocation).INLINE_COMMENT || location === (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT;
    const isTopPicker = location === (0, $3FlVr.ReactionLocation).PAGE || location === (0, $3FlVr.ReactionLocation).BLOGPOST;
    const commentExperimentAttributes = (0, $42omo.useMemo)(()=>isCommentReaction ? (0, $gtj7V.getCommentsDataManagerExperimentAttributes)() : {}, [
        isCommentReaction
    ]);
    const [{ searchSessionId: searchSessionId, additionalAnalytics: searchSessionIdAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const [reactedUsersMap, setReactedUsersMap] = (0, $42omo.useState)({});
    const [internalParticleEffectByEmoji, setInternalParticleEffectByEmoji] = (0, $42omo.useState)({});
    const [addReactionErrorState, setAddReactionErrorState] = (0, $42omo.useState)();
    const [deleteReactionErrorState, setDeleteReactionErrorState] = (0, $42omo.useState)();
    const timeoutHandle = (0, $42omo.useRef)();
    const { focusedPageReactionsId: focusedPageReactionsId, focusedCommentReactionsId: focusedCommentReactionsId, focusedCommentQuickReactionsId: focusedCommentQuickReactionsId, focusedPageQuickReactionsId: focusedPageQuickReactionsId, quickReactionsEmojiId: quickReactionsEmojiId, removeReactionsQueryParams: removeReactionsQueryParams } = (0, $ke5Nx.useReactionsQueryParams)();
    const [state] = (0, $isEtk.useContentState)();
    const contentType = (0, $5qhgL.getContentTypeByLocation)(location);
    const { isComment: isComment, isPage: isPage, isFeed: isFeed } = (0, $5qhgL.getBooleanLocationTypes)(location);
    const [addReaction] = (0, $308Wd.useMutationInterop)($f5eec8619482ab22$var$ReactionsConfluenceSaveReactionMutation);
    const [deleteReaction] = (0, $308Wd.useMutationInterop)($f5eec8619482ab22$var$ReactionsDeleteReactionMutation);
    const useNetworkOnly = (focusedCommentReactionsId === contentId || focusedCommentQuickReactionsId === contentId) && !firstRenderRef.current;
    const { data: { reactions: reactions, totalCount: totalCount, ari: ari, containerAri: containerAri }, loading: loading, error: error } = (0, $67ab6f98e2c53f50$export$66ed1c8ad044cd30)({
        location: location,
        contentId: contentId,
        containerId: containerId,
        inheritedReactionsData: reactionsData,
        reactedUsersMap: reactedUsersMap,
        useNetworkOnly: useNetworkOnly,
        limit: limit,
        sort: sort
    }); // Container for content types are adding extra margin which is affecting the new reaction styles (sidebar entrypoint/byline) so want to return default for this location
    const StyledContainer = (0, $5qhgL.getWrappingContainerByLocation)(useDefaultStyledContainer ? undefined : location);
    const perfSegment = isPage ? (0, $550b25d93e8d59fc$export$248a931886e2c02d) : isFeed ? (0, $550b25d93e8d59fc$export$7d316e4a12cc793d) : null;
    (0, $42omo.useEffect)(()=>{
        firstRenderRef.current = true;
        if (perfSegment) perfSegment.start();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const emojiProvider = (0, $42omo.useMemo)(()=>(0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
            cloudId: cloudId,
            userId: userId,
            // disabled b/c uploading is not playing nicely with reactions
            disableUpload: true
        }), [
        cloudId,
        userId
    ]); // For focused reactions, open the reaction picker menu
    // For quick reactions, add the reaction to the focused comment from the query params
    // state.contentLoading checks if the slowest content is loaded as to not displace reactions
    // do not use useLayoutEffect => delays render that messes up the document scroller
    (0, $42omo.useEffect)(()=>{
        (async ()=>{
            if (Object.entries(state.contentLoading).length === 0 && !loading) {
                // 1. Try overlay/hover picker first
                if (onlyRenderPicker && isComment && focusedCommentReactionsId === contentId) {
                    const overlayContainerId = `#reactions-container-${location}-${contentId}-onlyRenderPicker`;
                    const overlayContainer = document.querySelector(overlayContainerId);
                    const reactionsButton = overlayContainer.querySelector("span[aria-label='Add reaction']");
                    reactionsButton?.click();
                    return;
                } // 2. Fallback to main bar logic
                if (isPage && focusedPageReactionsId === contentId || isComment && focusedCommentReactionsId === contentId && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    const containerId = `#reactions-container-${location}-${contentId}`;
                    const reactionsContentContainer = document.querySelector(containerId);
                    if (reactionsContentContainer) {
                        // We only need to scroll when the page reaction query parameter is set otherwise
                        // we leverage the already existing scroll logic for page/inline comments
                        if (scrollFunctionRef.current && isPage) scrollFunctionRef.current(reactionsContentContainer);
                        const reactionsButton = reactionsContentContainer.querySelector("span[aria-label='Add reaction']"); // Open the reactions container
                        reactionsButton?.click();
                        return;
                    }
                } else if (!readOnly && quickReactionsEmojiId && (isComment && focusedCommentQuickReactionsId === contentId || isPage && focusedPageQuickReactionsId === contentId)) {
                    const emojiResource = await Promise.resolve(emojiProvider);
                    const foundEmoji = await emojiResource.findById(quickReactionsEmojiId);
                    if (isPage) {
                        const reactionsContentContainer = document.querySelector(`#reactions-container-${location}-${contentId}`);
                        if (reactionsContentContainer) {
                            if (scrollFunctionRef.current) scrollFunctionRef.current(reactionsContentContainer);
                        }
                    }
                    if (!foundEmoji) {
                        $f5eec8619482ab22$var$logger.log`Invalid query parameters provided for the 'addReaction' action`;
                        return;
                    }
                    onReactionsSelection(quickReactionsEmojiId, true);
                    removeReactionsQueryParams();
                }
            }
        })().catch((error)=>{
            $f5eec8619482ab22$var$logger.log`An error occurred while attempting to perform the reaction action from query parameters: ${error}`;
        }); // Omitting scrollFunctionRef.current from the dependency list b/c it causes extra renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        location,
        focusedPageReactionsId,
        focusedCommentReactionsId,
        focusedCommentQuickReactionsId,
        focusedPageQuickReactionsId,
        quickReactionsEmojiId,
        loading,
        isPage,
        isComment,
        state.contentLoading,
        readOnly,
        onlyRenderPicker
    ]); /**
                                                                                                                                                                                                                                                   * Separating the content status query from the reactions query b/c we need the
                                                                                                                                                                                                                                                   * content status for all display types (except feed), regardless of having reactionsData.
                                                                                                                                                                                                                                                   * Archiving/unarchiving a page only updates the page content status, so we
                                                                                                                                                                                                                                                   * always need to use the page ID when querying
                                                                                                                                                                                                                                                   */ 
    const { data: contentStatusData, error: contentStatusError } = (0, $jMyy4.useQueryInterop)($f5eec8619482ab22$var$ReactionsContentStatusQuery, {
        variables: {
            contentId: isComment ? containerId : contentId
        },
        skip: isFeed
    });
    const getUpdatedReactionsResponse = (0, $42omo.useCallback)((data, emojiId, actionType)=>{
        const summary = (0, $8wyJO.getReactionsSummary)(data);
        if (!summary) return;
        let updatedCount = summary.reactionsCount ?? 0;
        const updatedReactions = [
            ...summary.reactionsSummaryForEmoji ?? []
        ];
        const reactionObject = updatedReactions.find((item)=>item?.emojiId === emojiId);
        if (actionType === 'add') {
            // Check if the reaction already exists
            if (reactionObject && !reactionObject.reacted) {
                reactionObject.count++;
                reactionObject.reacted = true;
            } else {
                // If this type of reaction doesn't exist, create a new one
                const newReaction = {
                    emojiId: emojiId,
                    count: 1,
                    reacted: true,
                    id: `${summary.containerAri}|${summary.ari}|${emojiId}`,
                    __typename: 'ReactionsSummaryForEmoji'
                };
                updatedReactions.push(newReaction);
            } // Increment the total count of reactions
            updatedCount++;
        }
        if (actionType === 'delete') {
            // Remove the logged in users' reaction
            if (reactionObject && reactionObject.reacted && reactionObject.count > 1) {
                reactionObject.count--;
                reactionObject.reacted = false;
            } else {
                // If this is the last reaction of this type, remove it completely
                const removeIdx = updatedReactions.map((item)=>item?.emojiId).indexOf(emojiId);
                updatedReactions.splice(removeIdx, 1);
            } // Decrement the total count of reactions
            updatedCount--;
        }
        const getContentResponseData = ()=>{
            // Use type guards to ensure we have the correct data structure
            if ('content' in data && data.content?.nodes?.[0]) {
                const contentData = data;
                if (contentData.content?.nodes) return {
                    ...contentData,
                    content: {
                        ...contentData.content,
                        nodes: [
                            {
                                ...contentData.content.nodes[0],
                                contentReactionsSummary: {
                                    ...summary,
                                    reactionsSummaryForEmoji: updatedReactions,
                                    reactionsCount: updatedCount
                                }
                            }
                        ]
                    }
                };
            }
            return data;
        }; // Create the new updated response for the type of reaction and return it
        if (isComment && 'comments' in data && data.comments?.nodes?.[0]) {
            const commentsData = data;
            if (commentsData.comments?.nodes) return {
                ...commentsData,
                comments: {
                    ...commentsData.comments,
                    nodes: [
                        {
                            ...commentsData.comments.nodes[0],
                            reactionsSummary: {
                                ...summary,
                                reactionsSummaryForEmoji: updatedReactions,
                                reactionsCount: updatedCount
                            }
                        }
                    ]
                }
            };
        }
        return getContentResponseData();
    }, [
        isComment
    ]);
    const updateApolloCache = (0, $42omo.useCallback)((emojiId, actionType, onCacheUpdateError)=>(cache, result)=>{
            // If the mutation fails, don't do anything - shouldn't happen but satisfies TypeScript
            if (!result) return;
             // Skip this step if a parent component is already handling this
            if (Boolean(reactionsData) && updateCache) {
                updateCache(emojiId, actionType, contentId, containerId, cache, result, onCacheUpdateError);
                return;
            }
            const { query: query, queryVariables: queryVariables } = (0, $8wyJO.getReactionsQueryInfo)(isComment, contentId, containerId);
            const documentNodeQuery = (0, $86okN.toDocumentNode)(query);
            try {
                const response = cache.readQuery({
                    query: documentNodeQuery,
                    variables: queryVariables
                });
                const updatedResponse = getUpdatedReactionsResponse(response, emojiId, actionType);
                if (!updatedResponse) return;
                cache.writeQuery({
                    query: documentNodeQuery,
                    variables: queryVariables,
                    data: updatedResponse
                });
            } catch (err) {
                $f5eec8619482ab22$var$logger.error`An Error occurred when updating cache for ${location} reaction - ${err}`;
                if (err instanceof Error) onCacheUpdateError(err);
            }
        }, [
        contentId,
        containerId,
        isComment,
        location,
        getUpdatedReactionsResponse,
        updateCache,
        reactionsData
    ]);
    const handleRetryMutation = ()=>{
        if (addReactionErrorState) // Reset the mutation error state
        setAddReactionErrorState(undefined);
        if (deleteReactionErrorState) // Reset the mutation error state
        setDeleteReactionErrorState(undefined);
         /**
       * In the future we can retry the mutation,
       * however the memoized function for normalizing reaction data doesn't
       * react to changes in the apollo client cache soon enough. More investigation needed.
       */ 
    }; // Use external state if provided, otherwise use internal state
    const particleEffectByEmoji = externalParticleEffectByEmoji || internalParticleEffectByEmoji;
    const updateParticleEffect = (0, $42omo.useCallback)((emojiId, show)=>{
        if (onParticleEffectChange) onParticleEffectChange(emojiId, show);
        else setInternalParticleEffectByEmoji((prev)=>({
                ...prev,
                [emojiId]: show
            }));
    }, [
        onParticleEffectChange
    ]);
    const [pageLoadParticles, setPageLoadParticles] = (0, $42omo.useState)(new Set());
    const pageLoadAnimationCompleted = (0, $42omo.useRef)(false);
    const topThreeEmojis = (0, $42omo.useMemo)(()=>{
        if (!reactions.length) return [];
        return [
            ...reactions
        ].sort((a, b)=>b.count - a.count).slice(0, 3).map((r)=>r.emojiId);
    }, [
        reactions
    ]);
    (0, $42omo.useEffect)(()=>{
        if (renderParticleEffectOnLoad && !loading && reactions.length > 0 && !pageLoadAnimationCompleted.current) {
            const timeoutId = setTimeout(()=>{
                setPageLoadParticles(new Set(topThreeEmojis)); // Clear particles after animation
                setTimeout(()=>{
                    setPageLoadParticles(new Set());
                }, 1500); // Total animation duration
            }, 500);
            pageLoadAnimationCompleted.current = true;
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        loading,
        reactions,
        renderParticleEffectOnLoad,
        topThreeEmojis
    ]);
    const handleAddReactionMutationError = (0, $42omo.useCallback)((addMutationError, emojiIdx, quickReaction)=>{
        setAddReactionErrorState(addMutationError);
        experienceTracker.stopOnError({
            name: (0, $irVI7.ADD_REACTION_EXPERIENCE),
            error: addMutationError
        }); // Only manipulate activeReactionsRef when getOptimisticResponse is not provided
        if (!getOptimisticResponse && emojiIdx !== -1) activeReactionsRef.current.splice(emojiIdx, 1);
        if (quickReaction) experienceTracker.stopOnError({
            name: (0, $irVI7.ADD_QUICK_REACTION_EXPERIENCE),
            error: addMutationError
        });
    }, [
        experienceTracker,
        setAddReactionErrorState,
        getOptimisticResponse
    ]);
    const handleAddReactionCacheError = (0, $42omo.useCallback)((emojiIdx, quickReaction)=>(addMutationCacheError)=>{
            handleAddReactionMutationError(addMutationCacheError, emojiIdx, quickReaction);
        }, [
        handleAddReactionMutationError
    ]);
    const onReactionsSelection = (0, $42omo.useCallback)((emojiId, quickReaction)=>{
        if (focusedCommentReactionsId === contentId) removeReactionsQueryParams({
            reactionType: (0, $ke5Nx.ReactionType).COMMENT
        });
        if (addReactionErrorState || deleteReactionErrorState) {
            setAddReactionErrorState(undefined);
            setDeleteReactionErrorState(undefined);
        } // Skip activeReactionsRef checks when getOptimisticResponse is provided
        if (!getOptimisticResponse && activeReactionsRef.current.includes(emojiId)) return;
        const existingReaction = reactions.find((r)=>r.emojiId === emojiId);
        if (existingReaction && existingReaction.reacted) return;
         // Only manage activeReactionsRef when getOptimisticResponse is not provided
        const emojiIdx = getOptimisticResponse ? -1 : activeReactionsRef.current.length;
        if (!getOptimisticResponse) activeReactionsRef.current.push(emojiId);
         // Only add particle effects if not in summary view
        if (!summaryViewEnabled) updateParticleEffect(emojiId, true);
        if (quickReaction) experienceTracker.start({
            name: (0, $irVI7.ADD_QUICK_REACTION_EXPERIENCE),
            attributes: commentExperimentAttributes
        });
        experienceTracker.start({
            name: (0, $irVI7.ADD_REACTION_EXPERIENCE),
            attributes: {
                ...commentExperimentAttributes,
                type: location,
                placement: customAnalyticsAttributes.reactionsPlacement
            }
        });
        addReaction({
            variables: {
                cloudId: cloudId,
                contentId: Number(contentId),
                contentType: contentType?.toUpperCase(),
                containerId: Number(containerId),
                containerType: containerType?.toUpperCase(),
                emojiId: emojiId
            },
            update: updateApolloCache(emojiId, 'add', handleAddReactionCacheError(emojiIdx, quickReaction)),
            optimisticResponse: Boolean(updateCache) ? getOptimisticResponse?.({
                ari: ari,
                containerAri: containerAri,
                emojiId: emojiId,
                action: 'add'
            }) : $f5eec8619482ab22$var$getDefaultOptimisticResponse(emojiId)
        }).then(()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.ADD_REACTION_EXPERIENCE)
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'created',
                    actionSubject: 'reaction',
                    source: contentType,
                    attributes: {
                        objectId: contentId,
                        objectType: contentType,
                        containerId: containerId,
                        containerType: containerType,
                        emojiId: emojiId,
                        activationId: activationId,
                        accountId: userId,
                        displayType: location,
                        isLivePage: contentSubType === 'live',
                        reactionsStyle: isSubtle ? 'subtle' : 'classic',
                        searchSessionId: searchSessionId,
                        ...searchSessionIdAnalytics,
                        ...customAnalyticsAttributes,
                        popularFeedTimeGranularity: popularFeedTimeGranularity
                    }
                }
            }).fire(); // Only manipulate activeReactionsRef when getOptimisticResponse is not provided
            if (!getOptimisticResponse && emojiIdx !== -1) activeReactionsRef.current.splice(emojiIdx, 1);
            if (quickReaction) {
                experienceTracker.succeed({
                    name: (0, $irVI7.ADD_QUICK_REACTION_EXPERIENCE)
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'created',
                        actionSubject: 'quickReaction',
                        source: contentType,
                        attributes: {
                            objectId: contentId,
                            objectType: contentType,
                            containerId: containerId,
                            containerType: containerType,
                            emojiId: emojiId,
                            activationId: activationId,
                            accountId: userId,
                            displayType: location,
                            isLivePage: contentSubType === 'live',
                            reactionsStyle: isSubtle ? 'subtle' : 'classic',
                            ...customAnalyticsAttributes
                        }
                    }
                }).fire();
            }
        }).catch((error)=>{
            handleAddReactionMutationError(error, emojiIdx, quickReaction);
        });
    }, [
        focusedCommentReactionsId,
        contentId,
        addReactionErrorState,
        deleteReactionErrorState,
        reactions,
        summaryViewEnabled,
        experienceTracker,
        commentExperimentAttributes,
        location,
        customAnalyticsAttributes,
        addReaction,
        cloudId,
        contentType,
        containerId,
        containerType,
        updateApolloCache,
        handleAddReactionCacheError,
        updateCache,
        getOptimisticResponse,
        ari,
        containerAri,
        removeReactionsQueryParams,
        updateParticleEffect,
        createAnalyticsEvent,
        activationId,
        userId,
        contentSubType,
        isSubtle,
        searchSessionId,
        searchSessionIdAnalytics,
        popularFeedTimeGranularity,
        handleAddReactionMutationError
    ]);
    const handleDeleteReactionMutationError = (0, $42omo.useCallback)((deleteMutationError, emojiIdx)=>{
        setDeleteReactionErrorState(deleteMutationError);
        experienceTracker.stopOnError({
            name: (0, $irVI7.DELETE_REACTION_EXPERIENCE),
            error: deleteMutationError
        }); // Only manipulate activeReactionsRef when getOptimisticResponse is not provided
        if (!getOptimisticResponse && emojiIdx !== -1) activeReactionsRef.current.splice(emojiIdx, 1);
    }, [
        experienceTracker,
        setDeleteReactionErrorState,
        getOptimisticResponse
    ]);
    const handleDeleteReactionCacheError = (0, $42omo.useCallback)((emojiIdx)=>(deleteMutationCacheError)=>{
            handleDeleteReactionMutationError(deleteMutationCacheError, emojiIdx);
        }, [
        handleDeleteReactionMutationError
    ]); /* onReactionClick - A callback to handle when the user clicks on a reaction that has already been made
                                            *
                                            * NOTE: If the user has reacted already we will call the delete mutation, otherwise
                                            *       we call the function that handles the add mutation logic
                                            */ 
    const onReactionClick = (0, $42omo.useCallback)((emojiId)=>{
        // Skip activeReactionsRef checks when getOptimisticResponse is provided
        if (!getOptimisticResponse && activeReactionsRef.current.includes(emojiId)) return;
        if (addReactionErrorState || deleteReactionErrorState) {
            // the user might retry deleting a reaction without using the provided error link
            setDeleteReactionErrorState(undefined);
            setAddReactionErrorState(undefined);
        }
        const existingReaction = reactions.find((r)=>r.emojiId === emojiId); // If the current user has NOT reacted with this emoji, call the add function
        if (!existingReaction?.reacted) {
            onReactionsSelection(emojiId);
            return;
        } // Only manage activeReactionsRef when getOptimisticResponse is not provided
        const emojiIdx = getOptimisticResponse ? -1 : activeReactionsRef.current.length;
        if (!getOptimisticResponse) activeReactionsRef.current.push(emojiId);
         // Otherwise, we need to delete their reaction
        experienceTracker.start({
            name: (0, $irVI7.DELETE_REACTION_EXPERIENCE),
            attributes: {
                ...commentExperimentAttributes,
                type: location,
                placement: customAnalyticsAttributes.reactionsPlacement
            }
        });
        updateParticleEffect(emojiId, false);
        deleteReaction({
            variables: {
                contentId: contentId,
                contentType: contentType?.toUpperCase(),
                containerId: containerId,
                containerType: containerType?.toUpperCase(),
                emojiId: emojiId
            },
            update: updateApolloCache(emojiId, 'delete', handleDeleteReactionCacheError(emojiIdx)),
            optimisticResponse: getOptimisticResponse?.({
                ari: ari,
                containerAri: containerAri,
                emojiId: emojiId,
                action: 'delete'
            })
        }).then(()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.DELETE_REACTION_EXPERIENCE)
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'reaction',
                    source: contentType,
                    attributes: {
                        objectId: contentId,
                        objectType: contentType,
                        containerId: containerId,
                        containerType: containerType,
                        emojiId: emojiId,
                        activationId: activationId,
                        accountId: userId,
                        displayType: location,
                        isLivePage: contentSubType === 'live',
                        reactionsStyle: isSubtle ? 'subtle' : 'classic',
                        ...customAnalyticsAttributes
                    }
                }
            }).fire(); // Only manipulate activeReactionsRef when getOptimisticResponse is not provided
            if (!getOptimisticResponse && emojiIdx !== -1) activeReactionsRef.current.splice(emojiIdx, 1);
        }).catch((error)=>{
            handleDeleteReactionMutationError(error, emojiIdx);
        });
    }, [
        addReactionErrorState,
        deleteReactionErrorState,
        reactions,
        experienceTracker,
        commentExperimentAttributes,
        location,
        customAnalyticsAttributes,
        updateParticleEffect,
        deleteReaction,
        contentId,
        contentType,
        containerId,
        containerType,
        updateApolloCache,
        handleDeleteReactionCacheError,
        getOptimisticResponse,
        ari,
        containerAri,
        onReactionsSelection,
        createAnalyticsEvent,
        activationId,
        userId,
        contentSubType,
        isSubtle,
        handleDeleteReactionMutationError
    ]);
    const onReactionHover = (0, $42omo.useCallback)((emojiId)=>{
        // Skip activeReactionsRef checks when getOptimisticResponse is provided
        if (!getOptimisticResponse && activeReactionsRef.current.includes(emojiId) || reactions.length === 0) return;
        if (timeoutHandle.current) clearTimeout(timeoutHandle.current);
        timeoutHandle.current = setTimeout(()=>{
            experienceTracker.start({
                name: (0, $irVI7.VIEW_REACTION_USER_LIST_EXPERIENCE),
                attributes: {
                    ...commentExperimentAttributes,
                    contentId: contentId,
                    type: location,
                    emojiId: emojiId,
                    placement: customAnalyticsAttributes.reactionsPlacement
                }
            });
            (0, $c0rhi.queryInterop)({
                query: (0, $2OQgp.ReactedUsersQuery),
                variables: {
                    cloudId: cloudId,
                    contentId: contentId,
                    contentType: contentType?.toUpperCase(),
                    containerId: containerId,
                    containerType: containerType?.toUpperCase(),
                    emojiId: emojiId
                },
                fetchPolicy: 'network-only' // We need to fetch the latest list every hover so we don't miss new reactions
            }).then((res)=>{
                if (!res.data.reactedUsers) return;
                const { emojiId: reactedEmojiId, confluencePerson: confluencePerson } = res.data.reactedUsers; // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
                const users = confluencePerson.filter(Boolean).map((user)=>({
                        id: user?.accountId ?? '',
                        displayName: user?.displayName ?? ''
                    }));
                const updatedReactedUsersMap = {
                    ...reactedUsersMap
                };
                updatedReactedUsersMap[reactedEmojiId] = users;
                experienceTracker.succeed({
                    name: (0, $irVI7.VIEW_REACTION_USER_LIST_EXPERIENCE),
                    attributes: {
                        numReactions: users.length
                    }
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'hovered',
                        actionSubject: 'existingReaction',
                        source: contentType,
                        attributes: {
                            objectId: contentId,
                            containerId: containerId,
                            displayType: location,
                            emojiId: emojiId,
                            numReactions: users.length,
                            isLivePage: contentSubType === 'live',
                            reactionsStyle: isSubtle ? 'subtle' : 'classic',
                            ...customAnalyticsAttributes
                        }
                    }
                }).fire();
                setReactedUsersMap(updatedReactedUsersMap);
            }).catch((error)=>{
                $f5eec8619482ab22$var$logger.error`An error occured when user list for reaction - ${error}`;
                experienceTracker.stopOnError({
                    name: (0, $irVI7.VIEW_REACTION_USER_LIST_EXPERIENCE),
                    error: error
                });
            });
        }, 500);
    }, [
        getOptimisticResponse,
        reactions.length,
        experienceTracker,
        commentExperimentAttributes,
        contentId,
        location,
        customAnalyticsAttributes,
        cloudId,
        contentType,
        containerId,
        containerType,
        reactedUsersMap,
        createAnalyticsEvent,
        contentSubType,
        isSubtle
    ]);
    const updateReactionEvents = (event)=>{
        const newAttributes = {
            objectId: contentId,
            containerId: containerId,
            displayType: location,
            ...customAnalyticsAttributes
        };
        const updatedPayload = {
            ...event.payload,
            attributes: {
                ...event.payload.attributes,
                ...newAttributes
            }
        };
        event.update(updatedPayload);
    }; // WS-3494 - We interpret reactionsData being null as an error from the parent query
    const viewError = reactionsData === null ? new Error('Reactions failed to load from parent query') : error;
    const isArchivedPage = contentStatusData?.content?.nodes?.[0]?.status === 'archived'; // Disable add and delete reactions for archived pages and anonymous users
    const isDisabled = !isReactionsEnabled || isArchivedPage || !userId || false; // Delay reactions if slowest content is still loading and query params are present
    const delayForQueryParams = Object.entries(state.contentLoading).length > 0 && focusedPageReactionsId === contentId;
    const quickReactionEmojis = {
        ari: ari,
        containerAri: containerAri,
        emojiIds: (0, $ea7c14fef1b23d1f$export$68fb1297e1fdf33e)
    }; // Analytic event for opening Reactions Dialog
    const onDialogOpenCallback = (0, $42omo.useCallback)((emojiId, source)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'reactionsDialog',
                source: source || contentType,
                attributes: {
                    objectId: contentId,
                    objectType: contentType,
                    containerId: containerId,
                    containerType: containerType,
                    displayType: location,
                    isLivePage: contentSubType === 'live',
                    reactionsStyle: isSubtle ? 'subtle' : 'classic',
                    emojiId: emojiId,
                    ...customAnalyticsAttributes
                }
            }
        }).fire();
    }, [
        containerId,
        containerType,
        contentId,
        contentType,
        contentSubType,
        isSubtle,
        createAnalyticsEvent,
        location,
        customAnalyticsAttributes
    ]); // Analytic event for closing Reactions Dialog
    const onDialogCloseCallback = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'reactionsDialogCloseButton',
                source: contentType,
                attributes: {
                    objectId: contentId,
                    objectType: contentType,
                    containerId: containerId,
                    containerType: containerType,
                    displayType: location,
                    isLivePage: contentSubType === 'live',
                    reactionsStyle: isSubtle ? 'subtle' : 'classic',
                    ...customAnalyticsAttributes
                }
            }
        }).fire();
    }, [
        containerId,
        containerType,
        contentId,
        contentType,
        contentSubType,
        isSubtle,
        createAnalyticsEvent,
        location,
        customAnalyticsAttributes
    ]); // Analytic event for selecting an emoji from the Reactions Dialog emoji list
    const onDialogSelectReactionCallback = (0, $42omo.useCallback)((emojiId)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'selected',
                actionSubject: 'reactionsDialogEmojiList',
                source: contentType,
                attributes: {
                    objectId: contentId,
                    objectType: contentType,
                    containerId: containerId,
                    containerType: containerType,
                    displayType: location,
                    isLivePage: contentSubType === 'live',
                    reactionsStyle: isSubtle ? 'subtle' : 'classic',
                    emojiId: emojiId,
                    ...customAnalyticsAttributes
                }
            }
        }).fire();
    }, [
        containerId,
        containerType,
        contentId,
        contentType,
        contentSubType,
        isSubtle,
        createAnalyticsEvent,
        location,
        customAnalyticsAttributes
    ]); // Analytic event when changing pages inside the dialog
    const onDialogPageChangeCallback = (0, $42omo.useCallback)((emojiId, currentPage, maxPages)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'reactionsDialogPageNavigation',
                source: contentType,
                attributes: {
                    objectId: contentId,
                    objectType: contentType,
                    containerId: containerId,
                    containerType: containerType,
                    displayType: location,
                    isLivePage: contentSubType === 'live',
                    reactionsStyle: isSubtle ? 'subtle' : 'classic',
                    emojiId: emojiId,
                    currentPage: currentPage,
                    maxPages: maxPages,
                    ...customAnalyticsAttributes
                }
            }
        }).fire();
    }, [
        containerId,
        containerType,
        contentId,
        contentType,
        contentSubType,
        isSubtle,
        createAnalyticsEvent,
        location,
        customAnalyticsAttributes
    ]);
    const showPlaceholderComponent = (loading || delayForQueryParams) && !hidePlaceholder;
    const showViewErrorComponent = !showPlaceholderComponent && viewError;
    const showReactionsComponent = !showPlaceholderComponent && !showViewErrorComponent;
    const { isEligibleForSpotlight: isEligibleForSpotlight } = (0, $2c10e620583c8537$export$f37a6378fd099d73)({
        contentId: contentId,
        contentType: contentType,
        contentStatus: contentStatusData?.content?.nodes?.[0]?.status ?? undefined,
        isLivePage: contentSubType === 'live',
        // Skips the checks if the feature is disabled, i.e. in archived pages or for anonymous users
        skip: isDisabled
    });
    const spotlightAndOpenPickerConditions = isTopPicker && !loading && Object.entries(state.contentLoading).length === 0 && !readOnly && !isDisabled && !focusedPageReactionsId && !focusedPageQuickReactionsId && isEligibleForSpotlight;
    const shouldShowSpotlightAndOpenPicker = spotlightAndOpenPickerConditions && (0, $6mKj3.expValEquals)('contextual_collab_onboarding_for_new_end_users', 'cohort', 'experiment'); // fire A/A exposure
    spotlightAndOpenPickerConditions && (0, $6mKj3.expValEquals)('cc_engagement_contextual_collab_onboarding_for_neu_aa', 'cohort', 'experiment');
    (0, $42omo.useEffect)(()=>{
        if (shouldShowSpotlightAndOpenPicker) {
            const openReactionsPicker = ()=>{
                const pickerContainerId = `#reactions-container-${location}-${contentId}`;
                const reactionsContentContainer = document.querySelector(pickerContainerId);
                if (reactionsContentContainer) {
                    const reactionsButton = reactionsContentContainer.querySelector("button[aria-label='View all user reactions'], span[aria-label='Add reaction']");
                    reactionsButton?.click();
                }
            };
            if (typeof window !== 'undefined' && 'requestIdleCallback' in window) window.requestIdleCallback(()=>{
                try {
                    openReactionsPicker();
                } catch (callbackError) {
                    if (callbackError instanceof Error) $f5eec8619482ab22$var$logger.log`An error occurred while attempting to auto-open reaction picker: ${callbackError}`;
                }
            });
            else setTimeout(()=>{
                try {
                    openReactionsPicker();
                } catch (callbackError) {
                    if (callbackError instanceof Error) $f5eec8619482ab22$var$logger.log`An error occurred while attempting to auto-open reaction picker: ${callbackError}`;
                }
            }, 100);
        }
    }, [
        shouldShowSpotlightAndOpenPicker,
        location,
        contentId
    ]);
    const reactionsSummaryGetOptimisticImageURL = (0, $42omo.useCallback)((emojiId)=>{
        return (0, $yuV6Z.getOptimisticImageURL)(cloudId, emojiId, 'MDPI');
    }, [
        cloudId
    ]);
    const renderReactionsPlaceholder = ()=>{
        if (summaryViewEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), {
            useAccuratePills: isPage,
            onlyRenderPicker: onlyRenderPicker,
            customAnalyticsAttributes: customAnalyticsAttributes
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        key: String(contentId) + String(location),
        name: (0, $irVI7.VIEW_REACTIONS_EXPERIENCE),
        attributes: {
            ...commentExperimentAttributes,
            type: location,
            placement: customAnalyticsAttributes.reactionsPlacement
        }
    }), contentStatusError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentStatusError
    }), showPlaceholderComponent && renderReactionsPlaceholder(), showViewErrorComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9e5f8cfebc971936$export$1cbf5121ff654d85), {
        location: location,
        error: viewError
    }), showReactionsComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, pageLoadParticles.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5eec8619482ab22$var$RandomParticleEffect, {
        emojis: Array.from(pageLoadParticles),
        location: location,
        contentId: contentId,
        emojiProvider: emojiProvider,
        bylineContainerRef: bylineContainerRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40cb788b40fb0a3a$export$48224dc58d5614a5), {
        showSpotlight: shouldShowSpotlightAndOpenPicker
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(StyledContainer, {
        id: `reactions-container-${location}-${contentId}${onlyRenderPicker ? '-onlyRenderPicker' : ''}`,
        "data-testid": isDisabled ? 'disabled-reactions-container' : readOnly ? 'read-only-reactions-container' : 'reactions-container',
        "data-vc": "reactions-container",
        isDisabled: isDisabled,
        readOnly: readOnly,
        hasReactions: totalCount > 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        xcss: [
            $f5eec8619482ab22$var$reactionsContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        channel: "fabric-elements",
        onEvent: updateReactionEvents
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7G5ZJ.Reactions), {
        reactions: reactions,
        status: isDisabled || readOnly ? 'LOADING' : 'READY',
        loadReaction: $f5eec8619482ab22$var$noop,
        getReactionDetails: readOnly ? $f5eec8619482ab22$var$noop : onReactionHover,
        onSelection: isDisabled || readOnly ? $f5eec8619482ab22$var$noop : onReactionsSelection,
        onReactionClick: isDisabled || readOnly ? $f5eec8619482ab22$var$noop : onReactionClick,
        emojiProvider: emojiProvider,
        allowAllEmojis: true,
        quickReactionEmojis: location === 'page' ? quickReactionEmojis : undefined,
        onDialogOpenCallback: onDialogOpenCallback,
        onDialogCloseCallback: onDialogCloseCallback,
        onDialogSelectReactionCallback: onDialogSelectReactionCallback,
        onDialogPageChangeCallback: onDialogPageChangeCallback,
        allowUserDialog: allowUserDialog,
        particleEffectByEmoji: particleEffectByEmoji,
        summaryViewEnabled: summaryViewEnabled,
        summaryViewPlacement: summaryViewPlacement,
        showOpaqueBackground: summaryViewEnabled,
        subtleReactionsSummaryAndPicker: isSubtle,
        showAddReactionText: showAddReactionText && isSubtle && reactions.length === 0,
        hideDefaultReactions: isSubtle,
        ProfileCardWrapper: (0, $a6t12.ProfileCardWrapper),
        reactionPickerPlacement: reactionPickerPlacement,
        isViewOnly: isViewOnly || isArchivedPage,
        onlyRenderPicker: onlyRenderPicker,
        reactionPickerTriggerTooltipContent: reactionPickerTriggerTooltipContent,
        reactionPickerTriggerIcon: reactionPickerTriggerIcon,
        reactionPickerTriggerText: !onlyRenderPicker && summaryViewEnabled && reactions.length >= (summaryViewThreshold ?? 3) ? reactionPickerTriggerText : undefined,
        pickerQuickReactionEmojiIds: hoverableSummaryView && reactions.length > 0 ? [] : pickerQuickReactionEmojiIds,
        showSubtleDefaultReactions: showSubtleDefaultReactions,
        allowSelectFromSummaryView: allowSelectFromSummaryView,
        hoverableSummaryView: isReactionsEnabled && hoverableSummaryView,
        summaryViewThreshold: summaryViewThreshold,
        noRelativeContainer: noRelativeContainer,
        noWrap: noFlexWrap,
        useButtonAlignmentStyling: useButtonAlignmentStyling,
        isListItem: isListItem,
        summaryGetOptimisticImageURL: optimisticallyLoadSummaryEmojis && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? reactionsSummaryGetOptimisticImageURL : undefined,
        summaryButtonIconAfter: summaryButtonIconAfter,
        renderParticleEffectOnSummaryView: renderParticleEffectOnSummaryView
    })), totalCount === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $55d0a25426713acb$export$a1009b06367a4913), {
        isPage: isPage,
        isDisabled: isDisabled,
        readOnly: readOnly,
        isHidden: hideNoReactionsText,
        hasAnimation: animateNoReactionsText
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.VIEW_REACTIONS_EXPERIENCE)
    }), perfSegment && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
        metric: perfSegment,
        key: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aqvyf.DocumentScroller), null, ({ scrollToElement: scrollToElement })=>{
        scrollFunctionRef.current = scrollToElement;
        return null;
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab5f533f273a9a39$export$8dff3eb53fad3d32), {
        isPage: isPage,
        resetErrorStates: handleRetryMutation,
        addMutationError: addReactionErrorState,
        deleteMutationError: deleteReactionErrorState
    })))));
};
function $f5eec8619482ab22$var$_temp(index) {
    switch(index % 3){
        case 1:
            return -5;
        case 2:
            return 8;
        default:
            return -1;
    }
}
module.exports["Reactions"] = $f5eec8619482ab22$export$44cd1c46d5ca2376;

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("isEtk", function(module, exports) {

var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $0cd4a5fc89cb5961$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        isContentReady: false,
        contentLoading: {}
    },
    actions: {
        onContentRendered: ()=>({ setState: setState })=>{
                setState({
                    isContentReady: true
                });
            },
        addContentToBeLoaded: (content, value)=>({ setState: setState, getState: getState })=>{
                const newContentLoading = getState().contentLoading;
                newContentLoading[content] = value;
                setState({
                    contentLoading: newContentLoading
                });
            },
        removeContentFromLoading: (content)=>({ setState: setState, getState: getState })=>{
                const existingContentLoading = getState().contentLoading;
                existingContentLoading[content] && delete existingContentLoading[content];
                setState({
                    contentLoading: existingContentLoading
                });
            }
    },
    name: 'isContentReady'
});
const $0cd4a5fc89cb5961$export$fce89f7e653f0af5 = (0, $FOT9i.createContainer)($0cd4a5fc89cb5961$var$Store);
const $0cd4a5fc89cb5961$export$b49d63386d42e7ce = (0, $9zUhf.createHook)($0cd4a5fc89cb5961$var$Store);
module.exports["ContentStateContainer"] = $0cd4a5fc89cb5961$export$fce89f7e653f0af5;
module.exports["useContentState"] = $0cd4a5fc89cb5961$export$b49d63386d42e7ce;

});

parcelRegister("aqvyf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $4u5NT = parcelRequire("4u5NT");


var $hrAmX = parcelRequire("hrAmX");


var $8WfxO = parcelRequire("8WfxO");


var $gz8ZY = parcelRequire("gz8ZY");


var $fURMF = parcelRequire("fURMF");

const $db252f85a0d30c2c$export$1d45acea13d74309 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, scrollTarget: scrollTarget } = t0;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const topOffsetRef = (0, $42omo.useRef)(0);
    const { isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed, atlGeneralWebPanelHeight: atlGeneralWebPanelHeight } = (0, $8WfxO.useATLGeneralWebPanelListener)();
    const fixedWebPanelHeight = isATLGeneralWebPanelFixed ? atlGeneralWebPanelHeight : 0;
    let t1;
    if ($[0] !== fixedWebPanelHeight || $[1] !== isNav4Enabled || $[2] !== scrollTarget) {
        t1 = (element, isLivePage)=>{
            const topOffsetAdjustment = isNav4Enabled ? 0 : topOffsetRef.current;
            (0, $fURMF.scrollToElement)(element, -topOffsetAdjustment - fixedWebPanelHeight, "smooth", isLivePage);
            if (scrollTarget) (0, $4u5NT.abortAll)("new_interaction", `document-scroll:${scrollTarget}`);
        };
        $[0] = fixedWebPanelHeight;
        $[1] = isNav4Enabled;
        $[2] = scrollTarget;
        $[3] = t1;
    } else t1 = $[3];
    const adjustedScrollToElement = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            (0, $hrAmX.BannerStateContainer)
        ];
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== adjustedScrollToElement || $[6] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t2
        }, (bannerState)=>{
            topOffsetRef.current = bannerState.getTotalHeight();
            return children({
                scrollToElement: adjustedScrollToElement
            });
        });
        $[5] = adjustedScrollToElement;
        $[6] = children;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
$db252f85a0d30c2c$export$1d45acea13d74309.displayName = 'DocumentScroller';
module.exports["DocumentScroller"] = $db252f85a0d30c2c$export$1d45acea13d74309;

});

parcelRegister("gz8ZY", function(module, exports) {
/**----------------!!!!!!!!!!!!!!!!!!!!!!----------------------------
*   When Changing this file ensure you keep the pure function version
*              getIsNav4Enabled.ts in sync as well!
 -----------------!!!!!!!!!!!!!!!!!!!!!!!--------------------------*/ // eslint-disable-next-line confluence-feature-gating/inline-usage
const $90a9f787a509158d$export$22793b194a2253b9 = ()=>{
    return true;
};
module.exports["useIsNav4Enabled"] = $90a9f787a509158d$export$22793b194a2253b9;

});

parcelRegister("fURMF", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $1dnxO = parcelRequire("1dnxO");


var $9wGTI = parcelRequire("9wGTI");

const $e9d2c346c5e28ee8$var$logger = (0, $7W8i8.getLogger)('scroll-to-element');
const $e9d2c346c5e28ee8$export$aa10bd88079cd4f3 = 60;
/**
 * Returns the HTMLElement that should be used as the scroll root. By default, this is the window.
 * For Nav 4, this is the div with id=AkMainContent, if the id exists in the DOM
 *
 * @param isNav4Enabled - boolean
 */ function $e9d2c346c5e28ee8$var$getScrollRootElement(isNav4Enabled = false) {
    //if we are in mobile size for nav4, we should still scroll window.
    // the magic number below maps to media.above.md @media (min-width: 64rem)	1024px which sadly appears to have no means of access in pure JS
    if (isNav4Enabled && window.innerWidth > 1023 && document.getElementById('AkMainContent')) return document.getElementById('AkMainContent');
    return window;
}
const $e9d2c346c5e28ee8$var$explicitScrollListeners = new Set();
function $e9d2c346c5e28ee8$export$73ac910751bb2a9b(listener) {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.add(listener);
    return ()=>$e9d2c346c5e28ee8$var$explicitScrollListeners.delete(listener);
}


function $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners() {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.forEach((listener)=>{
        try {
            listener();
        } catch (error) {
            Promise.all([
                (parcelRequire("kI6Jo")),
                (parcelRequire("YiYda"))
            ]).then(([{ getMonitoringClient: getMonitoringClient }, { Attribution: Attribution }])=>{
                getMonitoringClient().submitError(error, {
                    attribution: Attribution.PAGE_EXTENSIONS
                });
            }).catch(()=>{
            // ignore errors, we can't do anything at this point
            });
        }
    });
}
function $e9d2c346c5e28ee8$var$isSmoothScrollSupported() {
    return 'scrollBehavior' in document.documentElement.style;
}
function $e9d2c346c5e28ee8$export$9b071b9c6dd786a2(isSmooth = false) {
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const scrollRootElement = $e9d2c346c5e28ee8$var$getScrollRootElement(isNav4Enabled);
    if (scrollRootElement) {
        //typecheck is convinced this can be null
        if (isSmooth && $e9d2c346c5e28ee8$var$isSmoothScrollSupported()) scrollRootElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        else scrollRootElement.scrollTo(0, 0);
    }
}
function $e9d2c346c5e28ee8$export$2353115f31f4d15(element, scrollCorrectionPixels, scrollBehavior = 'auto', isLivePage) {
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const scrollRootElement = isLivePage ? document.querySelector('.fabric-editor-popup-scroll-parent') : $e9d2c346c5e28ee8$var$getScrollRootElement(isNav4Enabled);
    let parentsOffset = 0;
    let currentOffsetParent = element.offsetParent;
    while(currentOffsetParent instanceof HTMLElement && currentOffsetParent != scrollRootElement){
        parentsOffset += currentOffsetParent.offsetTop;
        currentOffsetParent = currentOffsetParent.offsetParent;
    }
    const pageHeaderHeightAdjustment = isNav4Enabled ? (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? 56 : 0 : $e9d2c346c5e28ee8$export$aa10bd88079cd4f3;
    let top = element.offsetTop + (scrollCorrectionPixels || 0) + parentsOffset - pageHeaderHeightAdjustment;
    // check if element is nested inside table, if so we need to account for
    // sticky table header overlapping the element
    const hasTableParent = element?.closest('.pm-table-container td');
    if (hasTableParent && scrollCorrectionPixels) top = top + scrollCorrectionPixels * 1.25;
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    let behavior = scrollBehavior;
    if (behavior === 'smooth' && !$e9d2c346c5e28ee8$var$isSmoothScrollSupported()) behavior = 'auto';
    try {
        scrollRootElement?.scroll({
            top: top,
            behavior: behavior
        });
    } catch  {
        isNav4Enabled ? $e9d2c346c5e28ee8$var$logger.error`scroll() is not supported on #AkMainContent` : $e9d2c346c5e28ee8$var$logger.error`window.scroll() is not supported`;
    }
}
function $e9d2c346c5e28ee8$export$8611df79cae6484f(element) {
    const scrollContainer = document.getElementById('AkMainContent');
    const breadcrumbHeaderHeight = 56; // FixedSpaceHeaderContainer (top nav) of the classic full page
    if (scrollContainer && scrollContainer.contains(element)) {
        // Let the browser calculate the exact scroll position
        const savedScroll = scrollContainer.scrollTop;
        element.scrollIntoView({
            behavior: 'instant',
            block: 'start'
        });
        const targetScroll = scrollContainer.scrollTop;
        scrollContainer.scrollTop = savedScroll;
        scrollContainer.scrollTo({
            left: 0,
            top: targetScroll - breadcrumbHeaderHeight,
            behavior: 'smooth'
        });
    } else element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}
module.exports["scrollToPageStart"] = $e9d2c346c5e28ee8$export$9b071b9c6dd786a2;
module.exports["scrollToElement"] = $e9d2c346c5e28ee8$export$2353115f31f4d15;
module.exports["scrollToBlockForViewPage"] = $e9d2c346c5e28ee8$export$8611df79cae6484f;

});

parcelRegister("kI6Jo", function(module, exports) {

let $f13d236567563fe5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f13d236567563fe5$var$load("9fiFD").then(()=>parcelRequire('6SqQk'));

});

parcelRegister("YiYda", function(module, exports) {

let $0b5451c9b84ee3f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b5451c9b84ee3f1$var$load("fH5Zm").then(()=>parcelRequire('bZmZf'));

});

parcelRegister("8SCD6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $l5y3Y = parcelRequire("l5y3Y");

const $6881c6359fe8b822$export$4da9db299e81cd38 = /*#__PURE__*/ (0, $42omo.createContext)({
    isReactionsEnabled: false
});
$6881c6359fe8b822$export$4da9db299e81cd38.displayName = 'ReactionsContext';
const $6881c6359fe8b822$export$2157a4212fd7f5b1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { contentId: contentId, children: children } = t0;
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    let t1;
    if ($[0] !== isReactionsEnabled) {
        t1 = {
            isReactionsEnabled: isReactionsEnabled
        };
        $[0] = isReactionsEnabled;
        $[1] = t1;
    } else t1 = $[1];
    const reactionsContextValue = t1;
    let t2;
    if ($[2] !== children || $[3] !== reactionsContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
            value: reactionsContextValue
        }, children);
        $[2] = children;
        $[3] = reactionsContextValue;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ contentId: contentId, children: children })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const reactionsContextValue = (0, $42omo.useMemo)(()=>({
            isReactionsEnabled: isReactionsEnabled
        }), [
        isReactionsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
        value: reactionsContextValue
    }, children);
};
module.exports["ReactionsContext"] = $6881c6359fe8b822$export$4da9db299e81cd38;
module.exports["ReactionsProvider"] = $6881c6359fe8b822$export$2157a4212fd7f5b1;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("hjygH", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $1aeb691895c5954d$export$85823f26dca064c3(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("2OQgp", function(module, exports) {

var $6snPf = parcelRequire("6snPf");

const $b0d4ef9b24ddbdc3$export$e27c33fe32c2fd7b = (0, $6snPf.default);
module.exports["ReactedUsersQuery"] = $b0d4ef9b24ddbdc3$export$e27c33fe32c2fd7b;

});

parcelRegister("6snPf", function(module, exports) {
/**
 * @generated SignedSource<<ffad54f432cdffef3bc3c8dc431ff9a2>>
 * @relayHash a2be411b1772244feef74a2765f2ac57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8df3009a9d79522bd8efe037cb70fe5c72987241726fa1580e2f0eb97ceb9c96
const $d0a610df0853dabe$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerType"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "emojiId"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "containerId",
                    "variableName": "containerId"
                },
                {
                    "kind": "Variable",
                    "name": "containerType",
                    "variableName": "containerType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                },
                {
                    "kind": "Variable",
                    "name": "emojiId",
                    "variableName": "emojiId"
                }
            ],
            "concreteType": "ReactedUsersResponse",
            "kind": "LinkedField",
            "name": "reactedUsers",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                },
                {
                    "kind": "ScalarField",
                    "name": "reacted"
                },
                {
                    "concreteType": "ConfluencePerson",
                    "kind": "LinkedField",
                    "name": "confluencePerson",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactedUsersQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactedUsersQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "a2be411b1772244feef74a2765f2ac57",
            "id": "8df3009a9d79522bd8efe037cb70fe5c72987241726fa1580e2f0eb97ceb9c96",
            "metadata": {},
            "name": "ReactedUsersQuery",
            "operationKind": "query",
            "text": "query ReactedUsersQuery($contentId:String!,$containerId:String!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){reactedUsers(contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId){count,emojiId,reacted,confluencePerson{accountId,displayName,profilePicture{path}}}}"
        }
    };
}();
$d0a610df0853dabe$var$node.hash = "c015b4e131a157a2b697f6c2a7cdf8e3";
var $d0a610df0853dabe$export$2e2bcd8739ae039 = $d0a610df0853dabe$var$node;
module.exports["default"] = $d0a610df0853dabe$export$2e2bcd8739ae039;

});

parcelRegister("ewCYL", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

// helper function for page comment reactions styles
const $9204e37f72fd5b13$var$getPageCommentLeftMargin = (isDisabled)=>{
    if (isDisabled) // reactions-spacer is 5px wide
    return '0';
    else return '5px';
};
const $9204e37f72fd5b13$var$reactionsContainerStyles = null; // styling for disable state of reactions
const $9204e37f72fd5b13$var$disabledOrReadOnlyStyles = null; // hide the add reaction button and users dialog link for read-only
const $9204e37f72fd5b13$var$readOnlyStyles = null;
const $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 = ({ isDisabled: isDisabled, hasReactions: _hasReactions, readOnly: readOnly, ...props })=>{
    'use no memo';
    return /*#__PURE__*/ $42omo.createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1tr11xsr _sathhq3d _1i5z15vq _f7sg15vq _1ohd1ul9 _5f0qr5cr _1m31azsu",
            (isDisabled || readOnly) && "_1y1513gf _1m311rpy _4rtx13gf _1rjiglyw",
            readOnly && "_7jwlglyw _2yquglyw"
        ])
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$c7a67ebff2d113d4 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pk1y44 _2hwxgktf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _4cvr1y6m",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$b4e61fe3d4c2583b = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0idpf _19pk1y44",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // apply for inline comment on view or edit page
const $9204e37f72fd5b13$export$86c494d6cf94f63c = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t2;
        const t3 = __cmplp.isDisabled ? "var(--ds-text-subtlest, #6B6E76)" : "var(--ds-text-subtle, #505258)";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_10axpyj": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ $42omo.createElement(C, {
            ...__cmplp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1m311c3d",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$144e39595b801848 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pk1y44",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$6534fd4b5ea3346a = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "",
            !__cmplp.hasReactions && "_1e0c1txw _2lx21bp4 _4cvr1y6m _dw34s8vo _zi9xfajl _nindxy5q _1ozzazsu _13ysdlk8 _ubseazsu _5btvdlk8 _179eu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$a44f62ffda6523d1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1ul9p3fh _19pkpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$49f6fd955ad6275a = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u01b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["ReactionsContainer"] = $9204e37f72fd5b13$export$3dcc1cf4fc9c7641;
module.exports["PageReactionsContainer"] = $9204e37f72fd5b13$export$c7a67ebff2d113d4;
module.exports["PageCommentReactionsContainer"] = $9204e37f72fd5b13$export$b4e61fe3d4c2583b;
module.exports["InlineCommentReactionsContainer"] = $9204e37f72fd5b13$export$86c494d6cf94f63c;
module.exports["FeedReactionsContainer"] = $9204e37f72fd5b13$export$144e39595b801848;
module.exports["ObjectCommentFooterReactionsContainer"] = $9204e37f72fd5b13$export$6534fd4b5ea3346a;
module.exports["MutationErrorContainer"] = $9204e37f72fd5b13$export$a44f62ffda6523d1;

});

parcelRegister("8wyJO", function(module, exports) {

var $ibGN4 = parcelRequire("ibGN4");


var $3V1KT = parcelRequire("3V1KT");

const $01eec1a417789222$export$17ab88ef0193bb4 = (data)=>{
    if (!data) return data;
    if ($01eec1a417789222$var$isConfluenceContentReactions(data)) return data?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0];
    if ($01eec1a417789222$var$isContentReactions(data)) return data?.content?.nodes?.[0]?.contentReactionsSummary;
    if ($01eec1a417789222$var$isCommentReactions(data)) return data?.comments?.nodes?.[0]?.reactionsSummary;
};
const $01eec1a417789222$var$isConfluenceContentReactions = (data)=>Boolean(data.confluence_contentReactionsSummary);
const $01eec1a417789222$var$isContentReactions = (data)=>Boolean(data.content);
const $01eec1a417789222$var$isCommentReactions = (data)=>Boolean(data.comments);
const $01eec1a417789222$var$getReactionsContentQuery = ()=>{
    return 0, $3V1KT.ReactionsContentQuery;
};
const $01eec1a417789222$export$d765e1092b1f36ff = (isComment, contentId, containerId)=>{
    const query = isComment ? (0, $ibGN4.ReactionsCommentsQuery) : $01eec1a417789222$var$getReactionsContentQuery();
    const queryVariables = isComment ? {
        contentId: contentId,
        containerId: containerId
    } : {
        contentId: contentId
    };
    return {
        query: query,
        queryVariables: queryVariables
    };
};
module.exports["getReactionsSummary"] = $01eec1a417789222$export$17ab88ef0193bb4;
module.exports["getReactionsQueryInfo"] = $01eec1a417789222$export$d765e1092b1f36ff;

});

parcelRegister("ibGN4", function(module, exports) {

var $bcPqk = parcelRequire("bcPqk");

const $0c4d3fd1a40dc0de$export$c0002d0cc70e364a = (0, $bcPqk.default);
module.exports["ReactionsCommentsQuery"] = $0c4d3fd1a40dc0de$export$c0002d0cc70e364a;

});

parcelRegister("bcPqk", function(module, exports) {
/**
 * @generated SignedSource<<3dc4cd13757c8097f90e9c019f62dc38>>
 * @relayHash cbefab13307a82cf7144a0c0749ceeba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce
const $6247a0815b189874$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "contentStatus",
                    "value": [
                        "DRAFT",
                        "CURRENT"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "containerId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cbefab13307a82cf7144a0c0749ceeba",
            "id": "856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce",
            "metadata": {},
            "name": "ReactionsCommentsQuery",
            "operationKind": "query",
            "text": "query ReactionsCommentsQuery($contentId:ID!,$containerId:ID!){comments(commentId:$contentId,contentStatus:[DRAFT,CURRENT]){nodes{id,reactionsSummary(pageId:$containerId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$6247a0815b189874$var$node.hash = "0b21ca1826000dc79e07e5aee0fcca18";
var $6247a0815b189874$export$2e2bcd8739ae039 = $6247a0815b189874$var$node;
module.exports["default"] = $6247a0815b189874$export$2e2bcd8739ae039;

});

parcelRegister("3V1KT", function(module, exports) {

var $71jDq = parcelRequire("71jDq");

const $bb6fcff23ee99252$export$d1ed7f06ad741aec = (0, $71jDq.default);
module.exports["ReactionsContentQuery"] = $bb6fcff23ee99252$export$d1ed7f06ad741aec;

});

parcelRegister("71jDq", function(module, exports) {
/**
 * @generated SignedSource<<3cebf84094428ea2b6f9dabc2cda075e>>
 * @relayHash f5d80e75401b9c7d3d224f964fef6438
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4
const $380a75471f8fd0e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f5d80e75401b9c7d3d224f964fef6438",
            "id": "1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4",
            "metadata": {},
            "name": "ReactionsContentQuery",
            "operationKind": "query",
            "text": "query ReactionsContentQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$380a75471f8fd0e5$var$node.hash = "b632c435e4326f4f3245476cffd31162";
var $380a75471f8fd0e5$export$2e2bcd8739ae039 = $380a75471f8fd0e5$var$node;
module.exports["default"] = $380a75471f8fd0e5$export$2e2bcd8739ae039;

});

parcelRegister("5qhgL", function(module, exports) {

var $ewCYL = parcelRequire("ewCYL");


var $3FlVr = parcelRequire("3FlVr");

const $bfbd403eb560ce3e$export$610a53f6a2b349ea = (location)=>{
    switch(location){
        case (0, $3FlVr.ReactionLocation).PAGE:
        case (0, $3FlVr.ReactionLocation).BLOGPOST:
            return 0, $ewCYL.PageReactionsContainer;
        case (0, $3FlVr.ReactionLocation).PAGE_COMMENT:
            return 0, $ewCYL.PageCommentReactionsContainer;
        case (0, $3FlVr.ReactionLocation).INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT:
            return 0, $ewCYL.InlineCommentReactionsContainer;
        case (0, $3FlVr.ReactionLocation).FEED_PAGE:
        case (0, $3FlVr.ReactionLocation).FEED_BLOGPOST:
        case (0, $3FlVr.ReactionLocation).FEED_COMMENT:
            return 0, $ewCYL.FeedReactionsContainer;
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST:
            return 0, $ewCYL.ObjectCommentFooterReactionsContainer;
        default:
            return 0, $ewCYL.ReactionsContainer;
    }
};
const $bfbd403eb560ce3e$export$bab27241713f2853 = (location)=>{
    switch(location){
        case (0, $3FlVr.ReactionLocation).PAGE:
        case (0, $3FlVr.ReactionLocation).FEED_PAGE:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE:
            return 'page';
        case (0, $3FlVr.ReactionLocation).BLOGPOST:
        case (0, $3FlVr.ReactionLocation).FEED_BLOGPOST:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST:
            return 'blogpost';
        case (0, $3FlVr.ReactionLocation).PAGE_COMMENT:
        case (0, $3FlVr.ReactionLocation).INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).FEED_COMMENT:
            return 'comment';
    }
};
const $bfbd403eb560ce3e$export$ebc11b395f5b2d6c = (location)=>{
    let isPage = false;
    let isComment = false;
    let isFeed = false;
    switch(location){
        case (0, $3FlVr.ReactionLocation).PAGE:
        case (0, $3FlVr.ReactionLocation).BLOGPOST:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST:
            isPage = true;
            break;
        case (0, $3FlVr.ReactionLocation).FEED_PAGE:
        case (0, $3FlVr.ReactionLocation).FEED_BLOGPOST:
            isFeed = true;
            break;
        case (0, $3FlVr.ReactionLocation).PAGE_COMMENT:
        case (0, $3FlVr.ReactionLocation).INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT:
            isComment = true;
            break;
        // Feed comment is a special case that looks and queries like feed, but is technically a comment
        case (0, $3FlVr.ReactionLocation).FEED_COMMENT:
            isComment = true;
            isFeed = true;
            break;
    }
    return {
        isPage: isPage,
        isComment: isComment,
        isFeed: isFeed
    };
};
module.exports["getWrappingContainerByLocation"] = $bfbd403eb560ce3e$export$610a53f6a2b349ea;
module.exports["getContentTypeByLocation"] = $bfbd403eb560ce3e$export$bab27241713f2853;
module.exports["getBooleanLocationTypes"] = $bfbd403eb560ce3e$export$ebc11b395f5b2d6c;

});

parcelRegister("ke5Nx", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7zgzO = parcelRequire("7zgzO");

var $7176b627a488fb1c$export$eeec4f91154bc947 = /*#__PURE__*/ function(ReactionType) {
    ReactionType["COMMENT"] = "comment";
    return ReactionType;
}({});
const $7176b627a488fb1c$export$2278b801a31eb230 = ()=>{
    const $ = (0, $frIzR.c)(15);
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    if ($[0] !== getQueryParams) {
        t0 = getQueryParams();
        $[0] = getQueryParams;
        $[1] = t0;
    } else t0 = $[1];
    const { action: action, contentId: contentId, contentType: contentType, focusedCommentId: focusedCommentId, emojiId: emojiId } = t0;
    const reaction = action && action === "react";
    const quickReaction = action && action === "addReaction";
    const focusedPageReactionsId = reaction && contentType && (contentType === "page" || contentType === "blogpost") && contentId ? contentId : undefined;
    const focusedCommentReactionsId = reaction && focusedCommentId ? focusedCommentId : undefined;
    const quickReactionsEmojiId = quickReaction && emojiId ? emojiId : undefined;
    const focusedCommentQuickReactionsId = quickReactionsEmojiId && focusedCommentId ? focusedCommentId : undefined;
    const focusedPageQuickReactionsId = quickReaction && quickReactionsEmojiId && contentType && (contentType === "page" || contentType === "blogpost") && contentId ? contentId : undefined;
    let t1;
    if ($[2] !== action || $[3] !== emojiId || $[4] !== focusedCommentId || $[5] !== getQueryParams || $[6] !== setQueryParams) {
        t1 = (t2)=>{
            const { reactionType: reactionType } = t2 === undefined ? {} : t2;
            if (action && emojiId) {
                const queryParams = getQueryParams();
                setQueryParams({
                    ...queryParams,
                    action: undefined,
                    emojiId: undefined,
                    contentType: undefined,
                    contentId: undefined
                });
            } else if (reactionType === "comment" && action && focusedCommentId) {
                const queryParams_0 = getQueryParams();
                setQueryParams({
                    ...queryParams_0,
                    action: undefined,
                    focusedCommentId: undefined
                });
            }
        };
        $[2] = action;
        $[3] = emojiId;
        $[4] = focusedCommentId;
        $[5] = getQueryParams;
        $[6] = setQueryParams;
        $[7] = t1;
    } else t1 = $[7];
    const removeReactionsQueryParams = t1;
    let t2;
    if ($[8] !== focusedCommentQuickReactionsId || $[9] !== focusedCommentReactionsId || $[10] !== focusedPageQuickReactionsId || $[11] !== focusedPageReactionsId || $[12] !== quickReactionsEmojiId || $[13] !== removeReactionsQueryParams) {
        t2 = {
            focusedPageReactionsId: focusedPageReactionsId,
            focusedCommentReactionsId: focusedCommentReactionsId,
            focusedCommentQuickReactionsId: focusedCommentQuickReactionsId,
            focusedPageQuickReactionsId: focusedPageQuickReactionsId,
            quickReactionsEmojiId: quickReactionsEmojiId,
            removeReactionsQueryParams: removeReactionsQueryParams
        };
        $[8] = focusedCommentQuickReactionsId;
        $[9] = focusedCommentReactionsId;
        $[10] = focusedPageQuickReactionsId;
        $[11] = focusedPageReactionsId;
        $[12] = quickReactionsEmojiId;
        $[13] = removeReactionsQueryParams;
        $[14] = t2;
    } else t2 = $[14];
    return t2;
};
module.exports["ReactionType"] = $7176b627a488fb1c$export$eeec4f91154bc947;
module.exports["useReactionsQueryParams"] = $7176b627a488fb1c$export$2278b801a31eb230;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("ZugQS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");


var $4u5NT = parcelRequire("4u5NT");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $9wGTI = parcelRequire("9wGTI");


var $dPJCf = parcelRequire("dPJCf");

/**
 * Marks FMP (First Meaningful Paint) on UFO transition interactions.
 *
 * When the `confluence_fe_deprecate_bm3` feature gate is **disabled** (legacy BM3 mode),
 * this component does nothing — FMP for transitions is handled through the BM3 pipeline
 * (although unreliably, see investigation in CCP-7117).
 *
 * When the feature gate is **enabled** (UFO mode) and we are in a transition, this
 * component places an `addUFOCustomMark('fmp', timestamp)` call. Unlike `PageLoadMarkFMP`
 * which is meant for initial page loads, this component is specifically designed for SPA
 * transitions where the platform UFO library does not natively track FMP.
 *
 * The corresponding `metric:fmp` value is computed in `additionalPayloadData.ts` by
 * reading this mark from the interaction and calculating the offset from interaction start.
 */ const $70ecb93741312159$var$UFOTransitionMarkFMPComponent = ({ timestamp: timestamp })=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    (0, $42omo.useEffect)(()=>{
        if (isTransition && (0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) {
            (0, $kGwvc.addUFOCustomMark)('fmp', timestamp);
            // The code below unfortunately relies on internals of the UFO library and on some
            // knowledge of how the UFO event data (especially FMP) are processed by the analytics
            // pipeline. This is relatively stable "private API", but it has to be sorted out with
            // the UFO team, as a follow up to https://product-fabric.atlassian.net/browse/CCP-7117.
            const interaction = (0, $4u5NT.getActiveInteraction)();
            if (!interaction) return;
            // In UFO realm, there's no concept of FMP, and by design it is defaulted to TTAI. While
            // in Confluence we rely on FMP for transitions, so emulating the legacy behavior here.
            interaction.legacyMetrics = interaction.legacyMetrics || [];
            interaction.legacyMetrics.push({
                key: 'fmp',
                config: {
                    type: 'PAGE_LOAD'
                },
                start: 0,
                stop: timestamp ?? null,
                type: 'PAGE_LOAD',
                custom: {}
            });
        }
    }, [
        isTransition,
        timestamp
    ]);
    return null;
};
const $70ecb93741312159$export$f881402a7a312ba4 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($70ecb93741312159$var$UFOTransitionMarkFMPComponent);
module.exports["UFOTransitionMarkFMP"] = $70ecb93741312159$export$f881402a7a312ba4;

});

parcelRegister("2BQQi", function(module, exports) {

var $auRWi = parcelRequire("auRWi");


var $jMyy4 = parcelRequire("jMyy4");

const $513635d9ade3aacb$var$UseInlineHighlightsQuery = (0, $auRWi.default);
const $513635d9ade3aacb$export$7a17e81d6650ad94 = ({ pageId: pageId, shouldFireQuery: shouldFireQuery = true })=>{
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($513635d9ade3aacb$var$UseInlineHighlightsQuery, {
        variables: {
            pageId: pageId
        },
        skip: !Boolean(shouldFireQuery)
    });
    let markerRefs = [];
    let markerRefMap = {};
    const comments = data?.comments?.nodes;
    if (comments && Array.isArray(comments)) {
        // We need to create a map that connects markerRefs to commentId, we need commentId to fire analytic event
        // https://github.com/microsoft/TypeScript/issues/17002 - for type casting
        markerRefMap = comments.reduce((inlineRefAccumulator, comment)=>{
            if (!comment) return inlineRefAccumulator;
            const { inlineMarkerRef: inlineMarkerRef } = comment.location;
            // We should always get top-level inline comments, but if this doesn't exist, just return
            if (!inlineMarkerRef) return inlineRefAccumulator;
            inlineRefAccumulator[comment?.id] = inlineMarkerRef;
            comment?.replies?.forEach((reply)=>{
                if (reply) {
                    const { id: replyId } = reply;
                    inlineRefAccumulator[replyId] = inlineMarkerRef;
                }
            });
            return inlineRefAccumulator;
        }, {});
        markerRefs = [
            ...new Set(Object.values(markerRefMap))
        ];
    }
    return {
        markerRefs: markerRefs,
        markerRefMap: markerRefMap,
        loading: loading
    };
};
module.exports["useInlineHighlights"] = $513635d9ade3aacb$export$7a17e81d6650ad94;

});

parcelRegister("auRWi", function(module, exports) {
/**
 * @generated SignedSource<<ae6c0cd0e6b2ccebe266c857fe0c5bfd>>
 * @relayHash 1d98f028d17ad9f621bdfdae3f304d7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d1c7df039b34325b1be8894b47edfe979cd0fcb6539236903815bb381b9b21d
const $e084fe268cd37421$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            }
        ],
        "type": "InlineComment"
    }, v5 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInlineHighlightsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInlineHighlightsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1d98f028d17ad9f621bdfdae3f304d7b",
            "id": "4d1c7df039b34325b1be8894b47edfe979cd0fcb6539236903815bb381b9b21d",
            "metadata": {},
            "name": "useInlineHighlightsQuery",
            "operationKind": "query",
            "text": "query useInlineHighlightsQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:1000){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef}},replies{id}}}}"
        }
    };
}();
$e084fe268cd37421$var$node.hash = "2fb3b51eea98e2fd2a940548824e472b";
var $e084fe268cd37421$export$2e2bcd8739ae039 = $e084fe268cd37421$var$node;
module.exports["default"] = $e084fe268cd37421$export$2e2bcd8739ae039;

});

parcelRegister("c4PY4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $6mKj3 = parcelRequire("6mKj3");


var $1d2ww = parcelRequire("1d2ww");

const $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap = {
    [(0, $1d2ww.ContentAppearanceType).DEFAULT]: 'full-page',
    [(0, $1d2ww.ContentAppearanceType).FULL_WIDTH]: 'full-width',
    [(0, $1d2ww.ContentAppearanceType).MAX]: 'max'
};
const $e67a3bdaba93e18b$export$4ca444f48395eebe = (0, $2XqLN.default)((contentAppearance)=>{
    const appearanceForAtlaskit = $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[contentAppearance];
    // Fallback to 'full-width' if 'max' and experiment is off
    if (appearanceForAtlaskit === 'max' && !(0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) return 'full-width';
    if (appearanceForAtlaskit) return appearanceForAtlaskit;
    return $e67a3bdaba93e18b$export$e79a6aa49fcbdebe();
});
const $e67a3bdaba93e18b$export$e79a6aa49fcbdebe = ()=>{
    return $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[(0, $1d2ww.ContentAppearanceType).DEFAULT];
};
module.exports["getContentAppearanceForAtlaskit"] = $e67a3bdaba93e18b$export$4ca444f48395eebe;

});

parcelRegister("d2kvf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1HnpQ = parcelRequire("1HnpQ");


var $i3GYc = parcelRequire("i3GYc");

// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $7cea5ab07179eb6f$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $i3GYc.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1HnpQ.default), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
            children: children
        })
    });
};
var $7cea5ab07179eb6f$export$2e2bcd8739ae039 = $7cea5ab07179eb6f$var$TabPanel;
module.exports["default"] = $7cea5ab07179eb6f$export$2e2bcd8739ae039;

});


//# sourceMappingURL=Reactions.1aac17ac.js.map
